import { Injectable, Component, ElementRef, Input, NgModule } from '@angular/core';
import { mouse, select, scaleOrdinal, interpolate, arc, pie, scaleLinear, max, min, axisBottom, scaleBand, axisLeft, timeParse, csv, scaleTime, line, interpolateString } from 'd3';
import { WindowRef, BentoNotification } from '@bento/bento-ng';
import { __values, __assign } from 'tslib';
import { Directionality } from '@angular/cdk/bidi';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/chart.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@bento/bento-ng';
import * as ɵngcc2 from '@angular/cdk/bidi';
import * as ɵngcc3 from '@angular/common';

function BentoD3LineChartComponent_table_4_th_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.flatOptions["xAxis.title.text"], " ");
} }
function BentoD3LineChartComponent_table_4_td_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "td");
} }
function BentoD3LineChartComponent_table_4_th_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r5);
} }
function BentoD3LineChartComponent_table_4_tr_7_td_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var i_r10 = ctx.index;
    var seriesId_r7 = ɵngcc0.ɵɵnextContext().index;
    var ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.seriesData[i_r10].data[seriesId_r7]);
} }
function BentoD3LineChartComponent_table_4_tr_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "th", 11);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, BentoD3LineChartComponent_table_4_tr_7_td_3_Template, 2, 1, "td", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var xAxis_r6 = ctx.$implicit;
    var ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(xAxis_r6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.categories);
} }
function BentoD3LineChartComponent_table_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "table", 5);
    ɵngcc0.ɵɵelementStart(1, "thead");
    ɵngcc0.ɵɵelementStart(2, "tr");
    ɵngcc0.ɵɵtemplate(3, BentoD3LineChartComponent_table_4_th_3_Template, 2, 1, "th", 6);
    ɵngcc0.ɵɵtemplate(4, BentoD3LineChartComponent_table_4_td_4_Template, 1, 0, "td", 7);
    ɵngcc0.ɵɵtemplate(5, BentoD3LineChartComponent_table_4_th_5_Template, 2, 1, "th", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "tbody");
    ɵngcc0.ɵɵtemplate(7, BentoD3LineChartComponent_table_4_tr_7_Template, 4, 2, "tr", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.flatOptions["xAxis.title.text"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.flatOptions["xAxis.title.text"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.categories);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.xAxisCategories);
} }
var _c0 = ["*"];
var BentoD3ChartService = /** @class */ (function () {
    function BentoD3ChartService(windowRef) {
        this.windowRef = windowRef;
        this.defaultChartOptions = {
            marginTop: 20,
            marginRight: 20,
            marginBottom: 40,
            marginLeft: 50,
            width: 300,
            height: 300
        };
        this.defaultOptions = {
            chart: this.defaultChartOptions,
            plotOptions: {
                series: {
                    groupPadding: 0.24,
                    pointPadding: 0.2
                }
            }
        };
        this.defaultPieOptions = {
            chart: this.defaultChartOptions
        };
        this.document = windowRef.nativeDocument;
    }
    /**
     * @return {?}
     */
    BentoD3ChartService.prototype.tooltipID = /**
     * @return {?}
     */
    function () {
        return 'd3-tooltip-' + Math.round(Math.random() * 1000000);
    };
    /**
     * @param {?} tooltipID
     * @return {?}
     */
    BentoD3ChartService.prototype.tooltipHTML = /**
     * @param {?} tooltipID
     * @return {?}
     */
    function (tooltipID) {
        return ('<div id="' +
            tooltipID +
            '" class="bento-d3-tooltip top tooltip">' +
            '<div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>');
    };
    /**
     * @param {?} rawData
     * @param {?} categoryAxis
     * @return {?}
     */
    BentoD3ChartService.prototype.getD3Data = /**
     * @param {?} rawData
     * @param {?} categoryAxis
     * @return {?}
     */
    function (rawData, categoryAxis) {
        /** @type {?} */
        var data = [];
        rawData.series.forEach((/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            data[i] = {};
            data[i].name = d.name;
            /** @type {?} */
            var x0 = 0;
            /** @type {?} */
            var y0 = 0;
            data[i].barData = d.data.map((/**
             * @param {?} val
             * @param {?} j
             * @return {?}
             */
            function (val, j) {
                /** @type {?} */
                var barDataObj = {};
                // if data is array of object
                barDataObj.groupName = d.name;
                if (typeof val === 'object') {
                    barDataObj.name = val.name;
                    barDataObj.color = val.color;
                    if (categoryAxis === 'y') {
                        barDataObj.value = +val.x;
                        barDataObj.x0 = x0;
                        barDataObj.x1 = x0 += +val.x;
                    }
                    else if (categoryAxis === 'x') {
                        barDataObj.value = +val.y;
                        barDataObj.y0 = y0;
                        barDataObj.y1 = y0 += +val.y;
                    }
                }
                else if (rawData.yAxis && rawData.yAxis.categories) {
                    barDataObj.name = rawData.yAxis.categories[j];
                    barDataObj.value = +val;
                    barDataObj.x0 = x0;
                    barDataObj.x1 = x0 += +val;
                }
                else if (rawData.xAxis && rawData.xAxis.categories) {
                    barDataObj.name = rawData.xAxis.categories[j];
                    barDataObj.value = +val;
                    barDataObj.y0 = y0;
                    barDataObj.y1 = y0 += +val;
                }
                return barDataObj;
            }));
            // stacked total
            if (categoryAxis === 'y') {
                data[i].total = data[i].barData[data[i].barData.length - 1].x1;
            }
            else if (categoryAxis === 'x') {
                data[i].total = data[i].barData[data[i].barData.length - 1].y1;
            }
        }));
        return data;
    };
    /**
     * @param {?} obj
     * @return {?}
     */
    BentoD3ChartService.prototype.flattenObject = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        /** @type {?} */
        var toReturn = {};
        /** @type {?} */
        var flatObject;
        for (var i in obj) {
            if (!obj.hasOwnProperty(i)) {
                continue;
            }
            if (typeof obj[i] === 'object') {
                flatObject = this.flattenObject(obj[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) {
                        continue;
                    }
                    toReturn[i + (isNaN(Number(x)) ? '.' + x : '')] = flatObject[x];
                }
            }
            else {
                toReturn[i] = obj[i];
            }
        }
        return toReturn;
    };
    /**
     * @param {?} obj
     * @param {...?} args
     * @return {?}
     */
    BentoD3ChartService.prototype.checkNested = /**
     * @param {?} obj
     * @param {...?} args
     * @return {?}
     */
    function (obj) {
        var e_1, _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        try {
            for (var args_1 = __values(args), args_1_1 = args_1.next(); !args_1_1.done; args_1_1 = args_1.next()) {
                var arg = args_1_1.value;
                if (!obj || !obj.hasOwnProperty(arg)) {
                    return false;
                }
                obj = obj[arg];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (args_1_1 && !args_1_1.done && (_a = args_1.return)) _a.call(args_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return true;
    };
    /**
     * @param {?} obj
     * @param {?} style
     * @return {?}
     */
    BentoD3ChartService.prototype.applyStyle = /**
     * @param {?} obj
     * @param {?} style
     * @return {?}
     */
    function (obj, style) {
        /** @type {?} */
        var styleStr = '';
        for (var property in style) {
            if (style.hasOwnProperty(property)) {
                styleStr += this.camelToSnake(property) + ':' + style[property] + ';';
            }
        }
        obj.attr('style', styleStr);
    };
    /**
     * Convert bar/column chart to RTL
     */
    /**
     * Convert bar/column chart to RTL
     * @param {?} element
     * @param {?} svg
     * @param {?} flatOptions
     * @param {?} currentOptions
     * @param {?} xAxisTitle
     * @param {?} yAxisTitle
     * @param {?} yAxisText
     * @param {?} legend
     * @param {?} maxXAxisLabelHeight
     * @param {?} maxYAxisLabelWidth
     * @return {?}
     */
    BentoD3ChartService.prototype.makeRTL = /**
     * Convert bar/column chart to RTL
     * @param {?} element
     * @param {?} svg
     * @param {?} flatOptions
     * @param {?} currentOptions
     * @param {?} xAxisTitle
     * @param {?} yAxisTitle
     * @param {?} yAxisText
     * @param {?} legend
     * @param {?} maxXAxisLabelHeight
     * @param {?} maxYAxisLabelWidth
     * @return {?}
     */
    function (element, svg, flatOptions, currentOptions, xAxisTitle, yAxisTitle, yAxisText, legend, maxXAxisLabelHeight, maxYAxisLabelWidth) {
        svg.attr('transform', 'translate(' +
            (element.getBoundingClientRect().width - currentOptions.chart.marginLeft) +
            ',' +
            currentOptions.chart.marginTop +
            ') scale(-1,1)');
        /** @type {?} */
        var xAxisText = svg.selectAll('.x.axis text');
        // const isIE = !!this.nativeWindow.MSInputMethodContext && !!this.document.documentMode;
        /** @type {?} */
        var isIE = this.isIE();
        /** @type {?} */
        var anchorDirection = isIE ? 'start' : 'end';
        /** @type {?} */
        var xAxisPad = isIE ? 0.2 : 0.3;
        /** @type {?} */
        var titlePadRatio = isIE ? 0.75 : 1;
        if (flatOptions['xAxis.labels.rotation']) {
            xAxisText
                // select all the text elements for the xaxis
                .attr('transform', (/**
             * @return {?}
             */
            function () {
                return ('translate(' +
                    this.getBBox().height * -xAxisPad +
                    ',' +
                    this.getBBox().height * xAxisPad +
                    ')rotate(' +
                    flatOptions['xAxis.labels.rotation'] +
                    ' 0,0) scale(-1,1)');
            }))
                .style('text-anchor', anchorDirection)
                .attr('x', 0)
                .attr('y', 0);
        }
        else {
            xAxisText.attr('transform', 'scale(-1,1)');
        }
        if (xAxisTitle) {
            xAxisTitle
                .attr('transform', 'scale(-1,1)')
                .attr('x', -currentOptions.chart.width / 2)
                .style('text-anchor', 'middle')
                .attr('dy', maxXAxisLabelHeight * titlePadRatio);
        }
        if (yAxisTitle) {
            yAxisTitle
                .attr('transform', 'rotate(-90) scale(-1,1)')
                .attr('x', currentOptions.chart.height / 2)
                .attr('dy', maxYAxisLabelWidth * titlePadRatio);
        }
        if (yAxisText) {
            yAxisText
                .attr('transform', 'scale(-1,1)')
                .attr('text-anchor', anchorDirection)
                .attr('x', '9');
        }
        if (legend) {
            legend
                .select('text')
                .attr('x', -(currentOptions.chart.width - 21 + currentOptions.chart.marginRight))
                .attr('transform', 'scale(-1,1)')
                .style('text-anchor', anchorDirection);
        }
    };
    /**
     * @param {?} str
     * @return {?}
     */
    BentoD3ChartService.prototype.camelToSnake = /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        return str.replace(/([A-Z])/g, (/**
         * @param {?} $1
         * @return {?}
         */
        function ($1) { return '-' + $1.toLowerCase(); }));
    };
    /**
     * @param {?} d
     * @param {?} barElement
     * @param {?} element
     * @param {?} tooltipID
     * @param {?} tooltipFormatter
     * @param {?=} type
     * @param {?=} tooltip
     * @param {?=} tooltipNode
     * @return {?}
     */
    BentoD3ChartService.prototype.onMouseMove = /**
     * @param {?} d
     * @param {?} barElement
     * @param {?} element
     * @param {?} tooltipID
     * @param {?} tooltipFormatter
     * @param {?=} type
     * @param {?=} tooltip
     * @param {?=} tooltipNode
     * @return {?}
     */
    function (d, barElement, element, tooltipID, tooltipFormatter, type, tooltip, tooltipNode) {
        if (type === void 0) { type = ''; }
        /** @type {?} */
        var mousePos = mouse(element);
        /** @type {?} */
        var ox = mousePos[0] - barElement.clientLeft;
        /** @type {?} */
        var oy = mousePos[1] - barElement.clientTop;
        /** @type {?} */
        var barTip = tooltip || select('#' + tooltipID);
        /** @type {?} */
        var barTipNode = tooltipNode || this.document.getElementById(tooltipID);
        /** @type {?} */
        var tooltipTemplate = '';
        if (!tooltipFormatter) {
            if (d.name && d.value) {
                tooltipTemplate = d.name + ': ' + d.value;
            }
            if (type === 'lineRegular') {
                tooltipTemplate = d.valueX + '<br>' + tooltipTemplate;
            }
            else if (type === 'lineTracking') {
                tooltipTemplate += d.valueX + '<br>';
                d.series.forEach((/**
                 * @param {?} item
                 * @return {?}
                 */
                function (item) {
                    tooltipTemplate += item.name + ': ' + item.data + '<br>';
                }));
            }
        }
        else {
            tooltipTemplate = tooltipFormatter(d);
        }
        barTip.select('.tooltip-inner').html(tooltipTemplate);
        barTip
            .attr('class', 'bento-d3-tooltip top tooltip in')
            .style('left', ox - barTipNode.getBoundingClientRect().width / 2 + 'px')
            .style('top', oy - barTipNode.getBoundingClientRect().height - 10 + 'px')
            .style('display', 'block');
    };
    /**
     * @param {?} tooltipID
     * @return {?}
     */
    BentoD3ChartService.prototype.onMouseOut = /**
     * @param {?} tooltipID
     * @return {?}
     */
    function (tooltipID) {
        select('#' + tooltipID).style('display', 'none');
    };
    /**
     * @return {?}
     */
    BentoD3ChartService.prototype.isIE = /**
     * @return {?}
     */
    function () {
        return this.windowRef.isIE || this.windowRef.isIEEdge;
    };
    /** @nocollapse */
    BentoD3ChartService.ctorParameters = function () { return [
        { type: WindowRef }
    ]; };
BentoD3ChartService.ɵfac = function BentoD3ChartService_Factory(t) { return new (t || BentoD3ChartService)(ɵngcc0.ɵɵinject(ɵngcc1.WindowRef)); };
BentoD3ChartService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BentoD3ChartService, factory: function (t) { return BentoD3ChartService.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoD3ChartService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.WindowRef }]; }, null); })();
    return BentoD3ChartService;
}());
if (false) {
    /** @type {?} */
    BentoD3ChartService.prototype.defaultChartOptions;
    /** @type {?} */
    BentoD3ChartService.prototype.defaultOptions;
    /** @type {?} */
    BentoD3ChartService.prototype.defaultPieOptions;
    /**
     * @type {?}
     * @private
     */
    BentoD3ChartService.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoD3ChartService.prototype.windowRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/color.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoD3ColorService = /** @class */ (function () {
    function BentoD3ColorService() {
        this.bentoColors = {
            green: '#85ab44',
            orange: '#ff8000',
            red: '#dc0a0a',
            blue: '#1472c2'
        };
        this.chartColors = ['#98abc5', '#8a89a6', '#7b6888', '#6b486b', '#a05d56', '#d0743c', '#ff8c00'];
        this.brandColors = [
            '#DC0171',
            '#C28900',
            '#005DA2',
            '#0099C4',
            '#77A22D',
            '#387C2B',
            '#666666',
            '#9A8F84',
            '#37383D',
            '#DC0A0A',
            '#FF5900',
            '#5D1893'
        ];
        this.lineColors = [
            '#DC0171',
            '#C28900',
            '#005DA2',
            '#0099C4',
            '#77A22D',
            '#387C2B',
            '#666666',
            '#9A8F84',
            '#37383D',
            '#DC0A0A',
            '#FF5900',
            '#5D1893'
        ];
        this.colors = [
            '#dc0a0a',
            '#ff8000',
            '#ffb400',
            '#b2b2b8',
            '#606169',
            '#37383d',
            '#78a22f',
            '#397c2b',
            '#096352',
            '#0aa386',
            '#0083bf',
            '#005a84',
            '#a00000',
            '#dc0a0a',
            '#bf086d',
            '#f4317b',
            '#dd40c6',
            '#991a99',
            '#46166b',
            '#6234a4'
        ];
    }
    /**
     * @return {?}
     */
    BentoD3ColorService.prototype.brand10 = /**
     * @return {?}
     */
    function () {
        return ((/** @type {?} */ (scaleOrdinal()))).range(this.brandColors);
    };
    /**
     * @return {?}
     */
    BentoD3ColorService.prototype.line10 = /**
     * @return {?}
     */
    function () {
        return ((/** @type {?} */ (scaleOrdinal()))).range(this.lineColors);
    };
    /**
     * @return {?}
     */
    BentoD3ColorService.prototype.chart7 = /**
     * @return {?}
     */
    function () {
        return ((/** @type {?} */ (scaleOrdinal()))).range(this.chartColors);
    };
    /**
     * @return {?}
     */
    BentoD3ColorService.prototype.category20 = /**
     * @return {?}
     */
    function () {
        return ((/** @type {?} */ (scaleOrdinal()))).range(this.colors);
    };
    /**
     * @param {?} color
     * @return {?}
     */
    BentoD3ColorService.prototype.getBentoColors = /**
     * @param {?} color
     * @return {?}
     */
    function (color) {
        /** @type {?} */
        var bentoColor = color;
        if (this.bentoColors[color]) {
            bentoColor = this.bentoColors[color];
        }
        return bentoColor;
    };
    /**
     * @param {?} svg
     * @param {?} gradientName
     * @param {?} color1
     * @param {?} color2
     * @return {?}
     */
    BentoD3ColorService.prototype.addVerticalGradientDef = /**
     * @param {?} svg
     * @param {?} gradientName
     * @param {?} color1
     * @param {?} color2
     * @return {?}
     */
    function (svg, gradientName, color1, color2) {
        /** @type {?} */
        var gradient = svg
            .append('svg:defs')
            .append('svg:linearGradient')
            .attr('id', gradientName)
            .attr('x1', '0%')
            .attr('y1', '0%')
            .attr('x2', '0%')
            .attr('y2', '100%')
            .attr('spreadMethod', 'pad');
        gradient
            .append('svg:stop')
            .attr('offset', '0%')
            .attr('stop-color', color1)
            .attr('stop-opacity', 1);
        gradient
            .append('svg:stop')
            .attr('offset', '100%')
            .attr('stop-color', color2)
            .attr('stop-opacity', 1);
    };
    /**
     * @param {?} obj1
     * @param {?} obj2
     * @return {?}
     */
    BentoD3ColorService.prototype.mergeObjects = /**
     * @param {?} obj1
     * @param {?} obj2
     * @return {?}
     */
    function (obj1, obj2) {
        /* tslint:disable forin */
        for (var p in obj2) {
            try {
                // Property in destination object set; update its value.
                if (obj2[p].constructor === Object) {
                    obj1[p] = this.mergeObjects(obj1[p], obj2[p]);
                }
                else {
                    obj1[p] = obj2[p];
                }
            }
            catch (e) {
                // Property in destination object not set; create it and set its value.
                obj1[p] = obj2[p];
            }
        }
        return obj1;
    };
BentoD3ColorService.ɵfac = function BentoD3ColorService_Factory(t) { return new (t || BentoD3ColorService)(); };
BentoD3ColorService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BentoD3ColorService, factory: function (t) { return BentoD3ColorService.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoD3ColorService, [{
        type: Injectable
    }], function () { return []; }, null); })();
    return BentoD3ColorService;
}());
if (false) {
    /** @type {?} */
    BentoD3ColorService.prototype.bentoColors;
    /** @type {?} */
    BentoD3ColorService.prototype.chartColors;
    /** @type {?} */
    BentoD3ColorService.prototype.brandColors;
    /** @type {?} */
    BentoD3ColorService.prototype.lineColors;
    /** @type {?} */
    BentoD3ColorService.prototype.colors;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pie-chart/pie-chart.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * #### Requires BentoD3Module from `\@bento/bento-ng-d3`
 * A Pie and Donut chart built with [D3](http://d3js.org/).
 *
 * Be sure to provide a `height` via CSS to the Pie component or its container.
 *
 * **IMPORTANT:** Make sure to import `BentoD3Module` for this component to work:
 * ```typescript
 * import { BentoD3Module } from '\@bento/bento-ng-d3';
 * ```
 */
var BentoD3PieChartComponent = /** @class */ (function () {
    function BentoD3PieChartComponent(elRef, bentoColorService, bentoChartService, bentoNotification, dir) {
        var _this = this;
        this.bentoColorService = bentoColorService;
        this.bentoChartService = bentoChartService;
        this.dir = dir;
        this.tooltipID = this.bentoChartService.tooltipID();
        this.color = this.bentoColorService.brand10();
        this._currentDatum = [];
        this._currentDatumOuter = [];
        this._currentTextPos = [];
        this._currentTextLinePos = [];
        this._currentTextAnchorPos = [];
        this._hasInit = false;
        this._duration = 800;
        this.nativeEl = elRef.nativeElement;
        bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () { return _this._onResize(); }));
        this.isRtl = dir.value === 'rtl';
        dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.flipDirection();
        }));
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    BentoD3PieChartComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.options) {
            // TODO: Use deep extend, perhaps use lodash
            this.currentOptions = ((/** @type {?} */ (Object))).assign({}, this.bentoChartService.defaultPieOptions, this.options);
            if (this._hasInit) {
                this._onResize();
            }
        }
    };
    /**
     * @return {?}
     */
    BentoD3PieChartComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this._hasInit = true;
            /** @type {?} */
            var flatOptions = _this.bentoChartService.flattenObject(_this.currentOptions);
            if (flatOptions['plotOptions.pie.dataLabels.enabled']) {
                _this._showText(flatOptions['plotOptions.pie.dataLabels.inside']);
            }
        }), this._duration);
        this._onResize();
    };
    /**
     * Get the color of the pie slice by passing in the index
     */
    /**
     * Get the color of the pie slice by passing in the index
     * @param {?} i
     * @return {?}
     */
    BentoD3PieChartComponent.prototype.getColor = /**
     * Get the color of the pie slice by passing in the index
     * @param {?} i
     * @return {?}
     */
    function (i) {
        return this.options.series[0].data[i].color || this.color(i);
    };
    /**
     * Call this method when updating the data or options
     */
    /**
     * Call this method when updating the data or options
     * @return {?}
     */
    BentoD3PieChartComponent.prototype.refresh = /**
     * Call this method when updating the data or options
     * @return {?}
     */
    function () {
        this._onResize();
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3PieChartComponent.prototype._onResize = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.currentOptions && this.currentOptions.chart) {
            /** @type {?} */
            var elWidth = this.nativeEl.offsetWidth || this.currentOptions.chart.marginLeft + this.currentOptions.chart.marginRight;
            /** @type {?} */
            var elHeight = this.nativeEl.offsetHeight || this.currentOptions.chart.marginTop + this.currentOptions.chart.marginBottom;
            /** @type {?} */
            var newWidth = elWidth - this.currentOptions.chart.marginLeft - this.currentOptions.chart.marginRight;
            /** @type {?} */
            var newHeight = elHeight - this.currentOptions.chart.marginTop - this.currentOptions.chart.marginBottom;
            this.currentOptions.chart.width = this.currentOptions.chart.height = Math.min(newWidth, newHeight);
        }
        this._render();
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3PieChartComponent.prototype._render = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var _self = this;
        /** @type {?} */
        var bentoChartService = this.bentoChartService;
        /** @type {?} */
        var currentOptions = this.currentOptions;
        /** @type {?} */
        var options = this.options;
        /** @type {?} */
        var nativeEl = this.nativeEl;
        /** @type {?} */
        var tooltipID = this.tooltipID;
        /** @type {?} */
        var svg;
        /** @type {?} */
        var arc$1;
        /** @type {?} */
        var hoverArc;
        /** @type {?} */
        var pie$1;
        /** @type {?} */
        var polyline;
        /** @type {?} */
        var text;
        /** @type {?} */
        var outerArc;
        /** @type {?} */
        var height = currentOptions.chart.width;
        /** @type {?} */
        var width = height;
        /** @type {?} */
        var data = this._getD3PieData(options);
        /** @type {?} */
        var maxWidth = Math.max(nativeEl.offsetWidth, width);
        /** @type {?} */
        var maxHeight = nativeEl.offsetHeight;
        /** @type {?} */
        var radius = (this.options.series[0].size * Math.min(maxWidth, maxHeight)) / 2 || 300;
        /** @type {?} */
        var innerRadius = this.options.series[0].innerSize * radius || 0;
        /** @type {?} */
        var translateX = maxWidth / 2;
        /** @type {?} */
        var translateY = maxHeight / 2;
        /** @type {?} */
        var flatOptions = bentoChartService.flattenObject(currentOptions);
        /** @type {?} */
        var tooltipFormatter = flatOptions['tooltip.formatter'];
        /** @type {?} */
        var labelFormatter = flatOptions['plotOptions.pie.dataLabels.format'];
        /** @type {?} */
        var labelEnabled = flatOptions['plotOptions.pie.dataLabels.enabled'];
        /** @type {?} */
        var isLabelInside = flatOptions['plotOptions.pie.dataLabels.inside'];
        /** @type {?} */
        var allowPointSelect = flatOptions['plotOptions.series.allowPointSelect'];
        /** @type {?} */
        var tweenPie = (/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            if (!_self._hasInit) {
                /** @type {?} */
                var interpolate_1 = interpolate({ startAngle: 0, endAngle: 0 }, d);
                _self._currentDatum[i] = interpolate_1(0);
                return (/**
                 * @param {?} t
                 * @return {?}
                 */
                function (t) { return arc$1(interpolate_1(t)); });
            }
            else {
                /** @type {?} */
                var interpolate_2 = interpolate(_self._currentDatum[i], d);
                return (/**
                 * @param {?} t
                 * @return {?}
                 */
                function (t) { return arc$1(interpolate_2(t)); });
            }
        });
        /** @type {?} */
        var tweenPieOuter = (/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            if (!_self._hasInit) {
                /** @type {?} */
                var interpolate_3 = interpolate({ startAngle: 0, endAngle: 0 }, d);
                _self._currentDatumOuter[i] = interpolate_3(0);
                return (/**
                 * @param {?} t
                 * @return {?}
                 */
                function (t) { return hoverArc(interpolate_3(t)); });
            }
            else {
                /** @type {?} */
                var interpolate_4 = interpolate(_self._currentDatumOuter[i], d);
                return (/**
                 * @param {?} t
                 * @return {?}
                 */
                function (t) { return hoverArc(interpolate_4(t)); });
            }
        });
        /** @type {?} */
        var midAngle = (/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return d.startAngle + (d.endAngle - d.startAngle) / 2; });
        /** @type {?} */
        var onHoverOver = (/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            if (!allowPointSelect) {
                return;
            }
            /** @type {?} */
            var index = i + 1;
            /** @type {?} */
            var piePath = select(nativeEl).select('.hover-path:nth-child(' + index + ')');
            if (piePath.classed('selected')) {
                piePath.attr('class', 'hover-path selected');
            }
            else {
                piePath.attr('class', 'hover-path show');
            }
        });
        /** @type {?} */
        var onHoverOut = (/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            /** @type {?} */
            var index = i + 1;
            /** @type {?} */
            var piePath = select(nativeEl).select('.hover-path:nth-child(' + index + ')');
            if (piePath.classed('selected')) {
                piePath.attr('class', 'hover-path selected');
            }
            else {
                piePath.attr('class', 'hover-path');
            }
        });
        /** @type {?} */
        var onPathClicked = (/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            options.series[0].data.forEach((/**
             * @param {?} item
             * @param {?} itemIndex
             * @return {?}
             */
            function (item, itemIndex) {
                /** @type {?} */
                var index = itemIndex + 1;
                /** @type {?} */
                var currentPath = select(nativeEl).select('.hover-path:nth-child(' + index + ')');
                if (item.selected === true && itemIndex === i) {
                    if (allowPointSelect) {
                        currentPath.attr('class', 'hover-path show');
                    }
                    delete item.selected;
                }
                else if (itemIndex !== i && !item.selected) {
                    currentPath.attr('class', 'hover-path');
                    delete item.selected;
                }
                else {
                    if (allowPointSelect) {
                        currentPath.attr('class', 'hover-path selected');
                    }
                    item.selected = true;
                }
            }));
            // TODO: EMIT EVENT
        });
        // save current state of datum (for transition between data state)
        select(nativeEl)
            .selectAll('.path')
            .each((/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            _self._currentDatum[i] = d;
        }));
        select(nativeEl)
            .selectAll('.hover-path')
            .each((/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            _self._currentDatumOuter[i] = d;
        }));
        select(nativeEl)
            .select('.label-name')
            .selectAll('text')
            .each((/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            _self._currentTextPos[i] = d;
        }));
        select(nativeEl)
            .select('.lines')
            .selectAll('polyline')
            .each((/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            _self._currentTextLinePos[i] = d;
        }));
        // remove any previous svg element
        select(nativeEl)
            .select('svg')
            .remove();
        // construct new svg element
        svg = select(nativeEl)
            .append('svg')
            .attr('width', maxWidth)
            .attr('height', maxHeight)
            .append('g')
            .attr('transform', 'translate(' + translateX + ',' + translateY + ')');
        arc$1 = arc()
            .innerRadius(innerRadius * 0.8)
            .outerRadius(radius * 0.8);
        outerArc = arc()
            .innerRadius(radius * 0.9)
            .outerRadius(radius * 0.9);
        hoverArc = arc()
            .innerRadius(innerRadius * 0.8)
            .outerRadius(radius * 0.9);
        pie$1 = pie()
            .value((/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return d.value; }))
            .sort(null);
        svg
            .selectAll('.hover-path')
            .data(pie$1(data[0].pieData))
            .enter()
            .append('path')
            .attr('class', (/**
         * @param {?} d
         * @return {?}
         */
        function (d) {
            if (allowPointSelect && d.data.selected) {
                return 'hover-path selected';
            }
            else {
                return 'hover-path';
            }
        }))
            .attr('d', hoverArc)
            .attr('fill', (/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return d.data.color || _this.color(d.index); }))
            .transition()
            .duration(_self._duration)
            .attrTween('d', tweenPieOuter);
        svg
            .selectAll('.path')
            .data(pie$1(data[0].pieData))
            .enter()
            .append('path')
            .attr('class', 'path')
            .attr('d', arc$1)
            .attr('fill', (/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return d.data.color || _this.color(d.index); }))
            .on('mouseover', (/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            onHoverOver(d, i);
            bentoChartService.onMouseMove(d.data, this, nativeEl, tooltipID, tooltipFormatter);
        }))
            .on('mousemove', (/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            bentoChartService.onMouseMove(d.data, this, nativeEl, tooltipID, tooltipFormatter);
        }))
            .on('mouseout', (/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            onHoverOut(d, i);
            bentoChartService.onMouseOut(tooltipID);
        }))
            .on('mousedown', (/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            onPathClicked(d, i);
        }))
            .transition()
            .duration(_self._duration)
            .attrTween('d', tweenPie);
        // Text
        svg.append('g').attr('class', 'label-name');
        svg.append('g').attr('class', 'lines');
        text = svg
            .select('.label-name')
            .selectAll('text')
            .data(pie$1(data[0].pieData), (/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return d.data.name; }));
        text
            .enter()
            .append('text')
            .attr('dy', '.35em')
            .text((/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return (labelFormatter ? labelFormatter(d) : d.data.name + ': ' + d.value + '%'); }))
            .transition()
            .duration(_self._duration)
            .attrTween('transform', (/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            if (isLabelInside) {
                return _this.textTransformInner(d, i, arc$1, radius, midAngle);
            }
            else {
                return _this.textTransformOuter(d, i, outerArc, radius, midAngle);
            }
        }))
            .styleTween('text-anchor', (/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            if (isLabelInside) {
                return _this.textAnchorInner();
            }
            else {
                return _this.textAnchorOuter(d, i, midAngle);
            }
        }))
            .text((/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return (labelFormatter ? labelFormatter(d) : d.data.name + ': ' + d.value + '%'); }));
        text.exit().remove();
        // Polylines
        polyline = svg
            .select('.lines')
            .selectAll('polyline')
            .data(pie$1(data[0].pieData), (/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return d.data.name; }));
        polyline
            .enter()
            .append('polyline')
            .style('stroke', (/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return d.data.color || _this.color(d.index); }))
            .transition()
            .duration(_self._duration)
            .attrTween('points', (/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            _self._currentTextLinePos[i] = _self._currentTextLinePos[i] || d;
            /** @type {?} */
            var interpolate$1 = interpolate(_self._currentTextLinePos[i], d);
            _self._currentTextLinePos[i] = interpolate$1(0);
            return (/**
             * @param {?} t
             * @return {?}
             */
            function (t) {
                /** @type {?} */
                var d2 = interpolate$1(t);
                /** @type {?} */
                var pos = outerArc.centroid(d2);
                pos[0] = radius * 0.95 * (midAngle(d2) < Math.PI ? 1 : -1);
                /** @type {?} */
                var returnArr = [arc$1.centroid(d2), outerArc.centroid(d2), pos];
                return returnArr;
            });
        }));
        polyline.exit().remove();
        if (_self._hasInit && labelEnabled) {
            _self._showText(isLabelInside);
        }
    };
    /**
     * @private
     * @param {?} d
     * @param {?} i
     * @param {?} arc
     * @param {?} radius
     * @param {?} midAngle
     * @return {?}
     */
    BentoD3PieChartComponent.prototype.textTransformInner = /**
     * @private
     * @param {?} d
     * @param {?} i
     * @param {?} arc
     * @param {?} radius
     * @param {?} midAngle
     * @return {?}
     */
    function (d, i, arc, radius, midAngle) {
        this._currentTextPos[i] = this._currentTextPos[i] || d;
        /** @type {?} */
        var interpolate$1 = interpolate(this._currentTextPos[i], d);
        this._currentTextPos[i] = interpolate$1(0);
        return (/**
         * @param {?} t
         * @return {?}
         */
        function (t) {
            /** @type {?} */
            var d2 = interpolate$1(t);
            /** @type {?} */
            var pos = arc.centroid(d2);
            // pos[0]    = radius * (midAngle(d2) < Math.PI ? 1 : -1);
            return 'translate(' + pos + ')';
        });
    };
    /**
     * @private
     * @param {?} d
     * @param {?} i
     * @param {?} outerArc
     * @param {?} radius
     * @param {?} midAngle
     * @return {?}
     */
    BentoD3PieChartComponent.prototype.textTransformOuter = /**
     * @private
     * @param {?} d
     * @param {?} i
     * @param {?} outerArc
     * @param {?} radius
     * @param {?} midAngle
     * @return {?}
     */
    function (d, i, outerArc, radius, midAngle) {
        this._currentTextPos[i] = this._currentTextPos[i] || d;
        /** @type {?} */
        var interpolate$1 = interpolate(this._currentTextPos[i], d);
        this._currentTextPos[i] = interpolate$1(0);
        return (/**
         * @param {?} t
         * @return {?}
         */
        function (t) {
            /** @type {?} */
            var d2 = interpolate$1(t);
            /** @type {?} */
            var pos = outerArc.centroid(d2);
            pos[0] = radius * (midAngle(d2) < Math.PI ? 1 : -1);
            return 'translate(' + pos + ')';
        });
    };
    /**
     * @private
     * @param {?} d
     * @param {?} i
     * @param {?} midAngle
     * @return {?}
     */
    BentoD3PieChartComponent.prototype.textAnchorOuter = /**
     * @private
     * @param {?} d
     * @param {?} i
     * @param {?} midAngle
     * @return {?}
     */
    function (d, i, midAngle) {
        var _this = this;
        this._currentTextAnchorPos[i] = this._currentTextAnchorPos[i] || d;
        /** @type {?} */
        var interpolate$1 = interpolate(this._currentTextAnchorPos[i], d);
        this._currentTextAnchorPos[i] = interpolate$1(0);
        return (/**
         * @param {?} t
         * @return {?}
         */
        function (t) {
            /** @type {?} */
            var d2 = interpolate$1(t);
            /** @type {?} */
            var isLeft = midAngle(d2) < Math.PI;
            if (_this.isRtl && !_this.bentoChartService.isIE()) {
                isLeft = midAngle(d2) > Math.PI;
            }
            return isLeft ? 'start' : 'end';
        });
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3PieChartComponent.prototype.textAnchorInner = /**
     * @private
     * @return {?}
     */
    function () {
        return (/**
         * @param {?} t
         * @return {?}
         */
        function (t) {
            return 'middle';
        });
    };
    /**
     * @private
     * @param {?} isInside
     * @return {?}
     */
    BentoD3PieChartComponent.prototype._showText = /**
     * @private
     * @param {?} isInside
     * @return {?}
     */
    function (isInside) {
        select(this.nativeEl)
            .select('.label-name')
            .attr('class', 'label-name show');
        if (!isInside) {
            select(this.nativeEl)
                .select('.lines')
                .attr('class', 'lines show');
        }
    };
    /**
     * @private
     * @param {?} rawData
     * @return {?}
     */
    BentoD3PieChartComponent.prototype._getD3PieData = /**
     * @private
     * @param {?} rawData
     * @return {?}
     */
    function (rawData) {
        /** @type {?} */
        var data = [];
        rawData.series.forEach((/**
         * @param {?} d
         * @param {?} i
         * @return {?}
         */
        function (d, i) {
            data[i] = {};
            data[i].name = d.name;
            /** @type {?} */
            var total = 0;
            d.data.forEach((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                total += item.y;
            }));
            data[i].pieData = d.data.map((/**
             * @param {?} val
             * @param {?} j
             * @return {?}
             */
            function (val, j) {
                /** @type {?} */
                var pieDataObj = {};
                pieDataObj.name = val.name;
                pieDataObj.color = val.color;
                pieDataObj.value = +val.y;
                pieDataObj.percent = +val.y / total;
                pieDataObj.selected = val.selected;
                return pieDataObj;
            }));
        }));
        return data;
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3PieChartComponent.prototype.flipDirection = /**
     * @private
     * @return {?}
     */
    function () {
        this.isRtl = this.dir.value === 'rtl';
        this._onResize();
    };
    /** @nocollapse */
    BentoD3PieChartComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoD3ColorService },
        { type: BentoD3ChartService },
        { type: BentoNotification },
        { type: Directionality }
    ]; };
    BentoD3PieChartComponent.propDecorators = {
        options: [{ type: Input }]
    };
BentoD3PieChartComponent.ɵfac = function BentoD3PieChartComponent_Factory(t) { return new (t || BentoD3PieChartComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoD3ColorService), ɵngcc0.ɵɵdirectiveInject(BentoD3ChartService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Directionality)); };
BentoD3PieChartComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoD3PieChartComponent, selectors: [["bento-d3-pie-chart"]], inputs: { options: "options" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [[1, "bento-d3-tooltip", "top", "tooltip", 3, "id"], [1, "tooltip-arrow"], [1, "tooltip-inner"]], template: function BentoD3PieChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.tooltipID);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoD3PieChartComponent, [{
        type: Component,
        args: [{
                selector: 'bento-d3-pie-chart',
                template: "<div [id]=\"tooltipID\" class=\"bento-d3-tooltip top tooltip\">\n  <div class=\"tooltip-arrow\"></div>\n  <div class=\"tooltip-inner\"></div>\n</div>\n",
                providers: [BentoNotification]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: BentoD3ColorService }, { type: BentoD3ChartService }, { type: ɵngcc1.BentoNotification }, { type: ɵngcc2.Directionality }]; }, { options: [{
            type: Input
        }] }); })();
    return BentoD3PieChartComponent;
}());
if (false) {
    /** @type {?} */
    BentoD3PieChartComponent.prototype.options;
    /** @type {?} */
    BentoD3PieChartComponent.prototype.tooltipID;
    /**
     * @type {?}
     * @private
     */
    BentoD3PieChartComponent.prototype.isRtl;
    /**
     * @type {?}
     * @private
     */
    BentoD3PieChartComponent.prototype.nativeEl;
    /**
     * @type {?}
     * @private
     */
    BentoD3PieChartComponent.prototype.currentOptions;
    /**
     * @type {?}
     * @private
     */
    BentoD3PieChartComponent.prototype.color;
    /**
     * @type {?}
     * @private
     */
    BentoD3PieChartComponent.prototype._currentDatum;
    /**
     * @type {?}
     * @private
     */
    BentoD3PieChartComponent.prototype._currentDatumOuter;
    /**
     * @type {?}
     * @private
     */
    BentoD3PieChartComponent.prototype._currentTextPos;
    /**
     * @type {?}
     * @private
     */
    BentoD3PieChartComponent.prototype._currentTextLinePos;
    /**
     * @type {?}
     * @private
     */
    BentoD3PieChartComponent.prototype._currentTextAnchorPos;
    /**
     * @type {?}
     * @private
     */
    BentoD3PieChartComponent.prototype._hasInit;
    /**
     * @type {?}
     * @private
     */
    BentoD3PieChartComponent.prototype._duration;
    /**
     * @type {?}
     * @private
     */
    BentoD3PieChartComponent.prototype.bentoColorService;
    /**
     * @type {?}
     * @private
     */
    BentoD3PieChartComponent.prototype.bentoChartService;
    /**
     * @type {?}
     * @private
     */
    BentoD3PieChartComponent.prototype.dir;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/bar-chart/bar-chart.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * #### Requires BentoD3Module from `\@bento/bento-ng-d3`
 * This is a Bento component for horizontal bar charts built with
 * [D3](http://d3js.org/)
 * It currently supports four types: **Basic**, **Negative Values**, **Grouped**, and **Stacked**.
 *
 * **IMPORTANT:** Make sure to import `BentoD3Module` for this component to work:
 * ```typescript
 * import { BentoD3Module } from '\@bento/bento-ng-d3';
 * ```
 */
var BentoD3BarChartComponent = /** @class */ (function () {
    function BentoD3BarChartComponent(elRef, bentoColorService, bentoChartService, bentoNotification, dir) {
        var _this = this;
        this.bentoColorService = bentoColorService;
        this.bentoChartService = bentoChartService;
        this.dir = dir;
        this.tooltipID = this.bentoChartService.tooltipID();
        this.color = this.bentoColorService.brand10();
        this._currentRectBBox = [];
        this._currentMiddleYAxisBBox = {};
        this._hasInit = false;
        this._duration = 600;
        this.nativeEl = elRef.nativeElement;
        bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () { return _this._onResize(); }));
        this.isRtl = dir.value === 'rtl';
        dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.flipDirection();
        }));
    }
    /**
     * @return {?}
     */
    BentoD3BarChartComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this._hasInit = true;
        this._onResize();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    BentoD3BarChartComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.options) {
            // TODO: Use deep extend, perhaps use lodash
            this.currentOptions = ((/** @type {?} */ (Object))).assign({}, this.bentoChartService.defaultOptions, this.options);
            if (this._hasInit) {
                this._onResize();
            }
        }
    };
    /**
     * Call this method after updating data to refresh the visual representation
     */
    /**
     * Call this method after updating data to refresh the visual representation
     * @return {?}
     */
    BentoD3BarChartComponent.prototype.refresh = /**
     * Call this method after updating data to refresh the visual representation
     * @return {?}
     */
    function () {
        this._onResize();
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3BarChartComponent.prototype._onResize = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.currentOptions && this.currentOptions.chart) {
            this.currentOptions.chart.width =
                this.nativeEl.offsetWidth - this.currentOptions.chart.marginLeft - this.currentOptions.chart.marginRight;
        }
        this._render();
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3BarChartComponent.prototype._render = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var _self = this;
        /** @type {?} */
        var bentoChartService = this.bentoChartService;
        /** @type {?} */
        var currentOptions = this.currentOptions;
        /** @type {?} */
        var flatOptions = bentoChartService.flattenObject(currentOptions);
        /** @type {?} */
        var options = this.options;
        /** @type {?} */
        var nativeEl = this.nativeEl;
        /** @type {?} */
        var svg;
        /** @type {?} */
        var categories;
        if (options.yAxis && options.yAxis.categories) {
            categories = options.yAxis.categories;
        }
        else {
            /** @type {?} */
            var seriesData = options.series[0].data;
            categories = ((/** @type {?} */ (seriesData))).map((/**
             * @param {?} e
             * @return {?}
             */
            function (e) { return e.name; }));
        }
        // map data to D3 friendly format
        /** @type {?} */
        var data = bentoChartService.getD3Data(options, 'y');
        // save current state of bbox (for transition between data state)
        select(nativeEl)
            .selectAll('.bar-group')
            .each((/**
         * @param {?} col
         * @param {?} colIndex
         * @return {?}
         */
        function (col, colIndex) {
            _self._currentRectBBox[colIndex] = [];
            /** @type {?} */
            var bar = select(this).selectAll('.bar');
            bar.each((/**
             * @param {?} d
             * @param {?} i
             * @return {?}
             */
            function (d, i) {
                /** @type {?} */
                var rect = this;
                _self._currentRectBBox[colIndex][i] = rect.getBBox();
            }));
        }));
        // save current state of middle axis for transition
        select(nativeEl)
            .select('.y.axis.middle')
            .each((/**
         * @param {?} d
         * @return {?}
         */
        function (d) {
            /** @type {?} */
            var rect = this;
            _self._currentMiddleYAxisBBox = rect.getBBox();
        }));
        select(nativeEl)
            .select('svg')
            .remove();
        svg = select(nativeEl)
            .append('svg')
            .attr('width', '100%')
            .attr('height', options.chart.height + options.chart.marginTop + options.chart.marginBottom)
            .append('g');
        // Setup and Append X Axis
        /** @type {?} */
        var x = scaleLinear();
        // get max value from data
        /** @type {?} */
        var maxValue = Number(max(options.series, (/**
         * @param {?} obj
         * @return {?}
         */
        function (obj) {
            // check if data is array of object or values, if object
            if (typeof obj.data[0] === 'object') {
                return max(obj.data, (/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) { return e.x; }));
            }
            else {
                return max(obj.data);
            }
        })));
        // get min value from data
        /** @type {?} */
        var minValue = Number(min(options.series, (/**
         * @param {?} obj
         * @return {?}
         */
        function (obj) {
            if (typeof obj.data[0] === 'object') {
                return min(obj.data, (/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) { return e.x; }));
            }
            else {
                return min(obj.data);
            }
        })));
        // include 0 in y axis and give some vertical padding
        minValue = minValue > 0 ? 0 : minValue + minValue * 0.1;
        maxValue = maxValue < 0 ? 0 : maxValue + maxValue * 0.1;
        if (flatOptions['colors']) {
            this.color = scaleOrdinal().range(currentOptions.colors);
        }
        // calculate the x-axis domain
        if (flatOptions['plotOptions.series.stacking'] || flatOptions['plotOptions.bar.stacking']) {
            minValue = 0;
            maxValue = max(data, (/**
             * @param {?} d
             * @return {?}
             */
            function (d) { return Number(d.total); }));
            x.domain([maxValue, minValue])
                .nice()
                .range([currentOptions.chart.width, 0]);
        }
        else {
            x.domain([maxValue, minValue])
                .nice()
                .range([currentOptions.chart.width, 0]);
        }
        /** @type {?} */
        var xAxis = axisBottom(x);
        // check for custom xAxis label formatter
        if (flatOptions['xAxis.labels.formatter']) {
            xAxis.tickFormat(flatOptions['xAxis.labels.formatter']);
        }
        /** @type {?} */
        var xAxisContainer = svg
            .append('g')
            .attr('shape-rendering', 'crispEdges')
            .attr('transform', 'translate(0,' + currentOptions.chart.height + ')')
            .attr('class', 'x axis')
            .call(xAxis);
        // calc max x-axis Label Height
        /** @type {?} */
        var maxXAxisLabelHeight = 0;
        /** @type {?} */
        var xAxisText = xAxisContainer.selectAll('text');
        // apply styles to labels
        if (bentoChartService.checkNested(currentOptions, 'xAxis', 'labels', 'style')) {
            bentoChartService.applyStyle(xAxisText, currentOptions.xAxis.labels.style);
        }
        if (flatOptions['xAxis.labels.rotation']) {
            svg
                .selectAll('.x.axis text') //  select all the text elements for the xaxis
                .attr('transform', (/**
             * @return {?}
             */
            function () {
                return ('translate(' +
                    this.getBBox().height * -0.5 +
                    ',' +
                    this.getBBox().height * 0.5 +
                    ')rotate(' +
                    flatOptions['xAxis.labels.rotation'] +
                    ' 0,0)');
            }))
                .style('text-anchor', 'end')
                .attr('x', 0)
                .attr('y', 0);
        }
        xAxisText.each((/**
         * @return {?}
         */
        function () {
            if (this.getBBox().height > maxXAxisLabelHeight) {
                maxXAxisLabelHeight = this.getBoundingClientRect().height;
            }
        }));
        // check for x-axis title
        /** @type {?} */
        var xAxisTitle;
        if (flatOptions['xAxis.title.text']) {
            xAxisTitle = xAxisContainer
                .append('text')
                .attr('x', currentOptions.chart.width / 2)
                .style('text-anchor', 'middle')
                .text(flatOptions['xAxis.title.text']);
            maxXAxisLabelHeight = maxXAxisLabelHeight + xAxisTitle.node().getBoundingClientRect().height + 10;
            xAxisTitle.attr('dy', maxXAxisLabelHeight);
        }
        svg.attr('transform', 'translate(' + currentOptions.chart.marginLeft + ',' + currentOptions.chart.marginTop + ')');
        // create group margin, if there are grouped columns, provide more margin
        // if there is only one set of columns, have smaller margins
        /** @type {?} */
        var colGroupMargin = data.length > 1 ? flatOptions['plotOptions.series.groupPadding'] : 0;
        /** @type {?} */
        var colMargin = flatOptions['plotOptions.series.pointPadding'] || 0.2;
        // Set up and Append Y Axis
        /** @type {?} */
        var y0 = scaleBand()
            .range([0, currentOptions.chart.height])
            .padding(colGroupMargin)
            .round(true);
        /** @type {?} */
        var y1 = scaleBand();
        /** @type {?} */
        var yAxis = axisLeft(y0);
        if (flatOptions['yAxis.labels.formatter']) {
            yAxis.tickFormat(flatOptions['yAxis.labels.formatter']);
        }
        // if grouped or stacked, use names,
        // else use categories for y-axis labels
        yAxis = data.length > 1 ? axisLeft(y0) : axisLeft(y1);
        // set up y-axis domain
        y0.domain(data.map((/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return d.name; })));
        y1.domain(categories)
            .range([0, y0.bandwidth()])
            .padding(colMargin)
            .round(true);
        // y lines
        svg
            .selectAll('line.vertical-grid')
            .data(x.ticks())
            .enter()
            .append('line')
            .attr('class', 'vertical-grid')
            .attr('y1', 0)
            .attr('y2', currentOptions.chart.height)
            .attr('x1', (/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return x(d); }))
            .attr('x2', (/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return x(d); }))
            .style('stroke', '#000')
            .style('stroke-opacity', '0.1');
        // Append columns
        /** @type {?} */
        var barGroup = svg
            .selectAll('.bar-group')
            .data(data)
            .enter()
            .append('g')
            .attr('class', 'bar-group')
            .attr('transform', (/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return 'translate(0,' + y0(d.name) + ')'; }));
        /** @type {?} */
        var tooltipFormatter = flatOptions['tooltip.formatter'];
        /** @type {?} */
        var startBarWidth = (/**
         * @param {?} d
         * @param {?} i
         * @param {?} _colIndex
         * @return {?}
         */
        function (d, i, _colIndex) {
            if (_self._hasInit && _self._currentRectBBox.length > 0 && _self._currentRectBBox[_colIndex][i]) {
                return _self._currentRectBBox[_colIndex][i].width;
            }
            else {
                return 0;
            }
        });
        /** @type {?} */
        var startBarX = (/**
         * @param {?} d
         * @param {?} i
         * @param {?} _colIndex
         * @return {?}
         */
        function (d, i, _colIndex) {
            if (_self._hasInit && _self._currentRectBBox.length > 0 && _self._currentRectBBox[_colIndex][i]) {
                return _self._currentRectBBox[_colIndex][i].x;
            }
            else {
                return x(0);
            }
        });
        // Iterate through each bar group
        barGroup.each((/**
         * @param {?} _col
         * @param {?} _colIndex
         * @return {?}
         */
        function (_col, _colIndex) {
            var _this = this;
            /** @type {?} */
            var barRect = select(this)
                .selectAll('.bar')
                .data((/**
             * @param {?} d
             * @return {?}
             */
            function (d) { return d.barData; }))
                .enter()
                .append('rect')
                .on('mouseover', (/**
             * @param {?} d
             * @return {?}
             */
            function (d) {
                _self.bentoChartService.onMouseMove(d, this, _self.nativeEl, _self.tooltipID, tooltipFormatter);
            }))
                .on('mousemove', (/**
             * @param {?} d
             * @return {?}
             */
            function (d) {
                _self.bentoChartService.onMouseMove(d, _this, _self.nativeEl, _self.tooltipID, tooltipFormatter);
            }))
                .on('mouseout', (/**
             * @return {?}
             */
            function () {
                _self.bentoChartService.onMouseOut(_self.tooltipID);
            }))
                .attr('class', 'bar');
            //  if stacking option on
            if (flatOptions['plotOptions.series.stacking'] || flatOptions['plotOptions.bar.stacking']) {
                yAxis.scale(y0);
                barRect
                    .attr('height', y0.bandwidth())
                    .attr('fill', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) { return d.color || _self.color(d.name); }))
                    .attr('width', (/**
                 * @param {?} d
                 * @param {?} i
                 * @return {?}
                 */
                function (d, i) { return startBarWidth(d, i, _colIndex); }))
                    .attr('x', (/**
                 * @param {?} d
                 * @param {?} i
                 * @return {?}
                 */
                function (d, i) { return startBarX(d, i, _colIndex); }))
                    .transition()
                    .duration(_self._duration)
                    .attr('width', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) {
                    /** @type {?} */
                    var width = x(d.x1) - x(d.x0);
                    width = width > 0 ? width : 0;
                    return width;
                }))
                    .attr('x', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) { return x(d.x0); }));
            }
            else {
                barRect
                    .attr('y', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) { return y1(d.name); }))
                    .attr('height', y1.bandwidth())
                    .attr('fill', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) { return d.color || _self.color(d.name); }))
                    .attr('width', (/**
                 * @param {?} d
                 * @param {?} i
                 * @return {?}
                 */
                function (d, i) { return startBarWidth(d, i, _colIndex); }))
                    .attr('x', (/**
                 * @param {?} d
                 * @param {?} i
                 * @return {?}
                 */
                function (d, i) { return startBarX(d, i, _colIndex); }))
                    .transition()
                    .duration(_self._duration)
                    .attr('x', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) { return (d.value > 0 ? x(0) : x(d.value)); }))
                    .attr('width', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) { return Math.abs(x(d.value) - x(0)); }));
            }
            barRect
                .exit()
                .transition()
                .duration(300)
                .attr('width', 0)
                .remove();
        }));
        // Append y-axis over bars
        /** @type {?} */
        var yAxisContainer = svg
            .append('g')
            .attr('class', 'y axis')
            .attr('shape-rendering', 'crispEdges')
            .call(yAxis);
        if (flatOptions['yAxis.labels.style.fontSize']) {
            svg.selectAll('.y.axis text').attr('font-size', flatOptions['yAxis.labels.style.fontSize']);
        }
        // calc max y-axis Label Width
        /** @type {?} */
        var maxYAxisLabelWidth = 0;
        /** @type {?} */
        var yAxisText = yAxisContainer.selectAll('text');
        if (flatOptions['yAxis.labels.style.fontSize']) {
            yAxisText.attr('font-size', flatOptions['yAxis.labels.style.fontSize']);
        }
        yAxisText.each((/**
         * @return {?}
         */
        function () {
            if (this.getBBox().width > maxYAxisLabelWidth) {
                maxYAxisLabelWidth = this.getBBox().width;
            }
        }));
        // check for y-axis title
        /** @type {?} */
        var yAxisTitle;
        if (flatOptions['yAxis.title.text']) {
            yAxisTitle = yAxisContainer
                .append('text')
                .attr('transform', 'rotate(-90)')
                .attr('x', -currentOptions.chart.height / 2)
                .style('text-anchor', 'middle')
                .text(flatOptions['yAxis.title.text']);
            maxYAxisLabelWidth = -maxYAxisLabelWidth - yAxisTitle.node().getBBox().height - 2;
            yAxisTitle.attr('dy', maxYAxisLabelWidth);
        }
        if (minValue !== 0) {
            // show center divider xAxis if needed
            /** @type {?} */
            var startMidY_1 = (/**
             * @param {?} d
             * @return {?}
             */
            function (d) {
                if (_self._hasInit && _self._currentMiddleYAxisBBox && _self._currentMiddleYAxisBBox.x) {
                    return _self._currentMiddleYAxisBBox.x;
                }
                else {
                    return x(0);
                }
            });
            svg
                .append('g')
                .append('line')
                .attr('class', 'y axis middle')
                .attr('x1', (/**
             * @param {?} d
             * @return {?}
             */
            function (d) { return startMidY_1(d); }))
                .attr('x2', (/**
             * @param {?} d
             * @return {?}
             */
            function (d) { return startMidY_1(d); }))
                .attr('y2', currentOptions.chart.height)
                .transition()
                .duration(_self._duration)
                .attr('x1', x(0))
                .attr('x2', x(0));
        }
        //  if grouped columns, show legend
        /** @type {?} */
        var legend;
        if (flatOptions['legend.enabled'] !== false &&
            (data.length > 1 || (flatOptions['plotOptions.series.stacking'] || flatOptions['plotOptions.bar.stacking']))) {
            legend = svg
                .selectAll('.legend')
                .data(categories.slice())
                .enter()
                .append('g')
                .attr('class', 'legend')
                .attr('transform', (/**
             * @param {?} d
             * @param {?} i
             * @return {?}
             */
            function (d, i) { return 'translate(0,' + i * 19 + ')'; }));
            legend
                .append('rect')
                .attr('x', currentOptions.chart.width - 15 + currentOptions.chart.marginRight)
                .attr('width', 15)
                .attr('height', 15)
                .style('fill', this.color);
            legend
                .append('text')
                .attr('x', currentOptions.chart.width - 21 + currentOptions.chart.marginRight)
                .attr('y', 9)
                .attr('dy', '.15em')
                .style('text-anchor', 'end')
                .text((/**
             * @param {?} d
             * @return {?}
             */
            function (d) { return d; }));
        }
        if (this.isRtl) {
            this.bentoChartService.makeRTL(nativeEl, svg, flatOptions, currentOptions, xAxisTitle, yAxisTitle, yAxisText, legend, maxXAxisLabelHeight, maxYAxisLabelWidth);
        }
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3BarChartComponent.prototype.flipDirection = /**
     * @private
     * @return {?}
     */
    function () {
        this.isRtl = this.dir.value === 'rtl';
        this._onResize();
    };
    /** @nocollapse */
    BentoD3BarChartComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoD3ColorService },
        { type: BentoD3ChartService },
        { type: BentoNotification },
        { type: Directionality }
    ]; };
    BentoD3BarChartComponent.propDecorators = {
        options: [{ type: Input }]
    };
BentoD3BarChartComponent.ɵfac = function BentoD3BarChartComponent_Factory(t) { return new (t || BentoD3BarChartComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoD3ColorService), ɵngcc0.ɵɵdirectiveInject(BentoD3ChartService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Directionality)); };
BentoD3BarChartComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoD3BarChartComponent, selectors: [["bento-d3-bar-chart"]], inputs: { options: "options" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [[1, "bento-d3-tooltip", "top", "tooltip", 3, "id"], [1, "tooltip-arrow"], [1, "tooltip-inner"]], template: function BentoD3BarChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.tooltipID);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoD3BarChartComponent, [{
        type: Component,
        args: [{
                selector: 'bento-d3-bar-chart',
                template: "<div [id]=\"tooltipID\" class=\"bento-d3-tooltip top tooltip\">\n  <div class=\"tooltip-arrow\"></div>\n  <div class=\"tooltip-inner\"></div>\n</div>\n",
                providers: [BentoNotification]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: BentoD3ColorService }, { type: BentoD3ChartService }, { type: ɵngcc1.BentoNotification }, { type: ɵngcc2.Directionality }]; }, { options: [{
            type: Input
        }] }); })();
    return BentoD3BarChartComponent;
}());
if (false) {
    /**
     * Bar Chart Options - Please use the BentoChartOptions interface (see below API)
     * @type {?}
     */
    BentoD3BarChartComponent.prototype.options;
    /** @type {?} */
    BentoD3BarChartComponent.prototype.tooltipID;
    /**
     * @type {?}
     * @private
     */
    BentoD3BarChartComponent.prototype.isRtl;
    /**
     * @type {?}
     * @private
     */
    BentoD3BarChartComponent.prototype.nativeEl;
    /**
     * @type {?}
     * @private
     */
    BentoD3BarChartComponent.prototype.currentOptions;
    /**
     * @type {?}
     * @private
     */
    BentoD3BarChartComponent.prototype.color;
    /**
     * @type {?}
     * @private
     */
    BentoD3BarChartComponent.prototype._currentRectBBox;
    /**
     * @type {?}
     * @private
     */
    BentoD3BarChartComponent.prototype._currentMiddleYAxisBBox;
    /**
     * @type {?}
     * @private
     */
    BentoD3BarChartComponent.prototype._hasInit;
    /**
     * @type {?}
     * @private
     */
    BentoD3BarChartComponent.prototype._duration;
    /**
     * @type {?}
     * @private
     */
    BentoD3BarChartComponent.prototype.bentoColorService;
    /**
     * @type {?}
     * @private
     */
    BentoD3BarChartComponent.prototype.bentoChartService;
    /**
     * @type {?}
     * @private
     */
    BentoD3BarChartComponent.prototype.dir;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/column-chart/column-chart.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * #### Requires BentoD3Module from `\@bento/bento-ng-d3`
 * This is a Bento component for vertical bar charts built with
 * [D3](http://d3js.org/).
 * It currently supports four types:
 * **Basic**, **Negative Values**,
 * **Grouped**, and **Stacked**.
 *
 * **IMPORTANT:** Make sure to import `BentoD3Module` for this component to work:
 * ```typescript
 * import { BentoD3Module } from '\@bento/bento-ng-d3';
 * ```
 */
var BentoD3ColumnChartComponent = /** @class */ (function () {
    function BentoD3ColumnChartComponent(elRef, bentoColorService, bentoChartService, bentoNotification, dir) {
        var _this = this;
        this.bentoColorService = bentoColorService;
        this.bentoChartService = bentoChartService;
        this.dir = dir;
        this.tooltipID = this.bentoChartService.tooltipID();
        this.color = this.bentoColorService.brand10();
        this._currentRectBBox = [];
        this._currentMiddleXAxisBBox = {};
        this._duration = 600;
        this._hasInit = false;
        this.nativeEl = elRef.nativeElement;
        bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () { return _this._onResize(); }));
        this.isRtl = dir.value === 'rtl';
        dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.flipDirection();
        }));
    }
    /**
     * @return {?}
     */
    BentoD3ColumnChartComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this._hasInit = true;
        this._onResize();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    BentoD3ColumnChartComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.options) {
            // TODO: Use deep extend, perhaps use lodash
            this.currentOptions = ((/** @type {?} */ (Object))).assign({}, this.bentoChartService.defaultOptions, this.options);
            if (this._hasInit) {
                this._onResize();
            }
            // console.log('currentOptions',this.currentOptions);
        }
    };
    /**
     * Call this method after updating data to refresh the visual representation
     */
    /**
     * Call this method after updating data to refresh the visual representation
     * @return {?}
     */
    BentoD3ColumnChartComponent.prototype.refresh = /**
     * Call this method after updating data to refresh the visual representation
     * @return {?}
     */
    function () {
        this._onResize();
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3ColumnChartComponent.prototype._onResize = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.currentOptions && this.currentOptions.chart) {
            this.currentOptions.chart.width =
                this.nativeEl.offsetWidth - this.currentOptions.chart.marginLeft - this.currentOptions.chart.marginRight;
        }
        this._render();
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3ColumnChartComponent.prototype._render = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var _self = this;
        /** @type {?} */
        var bentoChartService = this.bentoChartService;
        /** @type {?} */
        var currentOptions = this.currentOptions;
        /** @type {?} */
        var options = this.options;
        /** @type {?} */
        var nativeEl = this.nativeEl;
        /** @type {?} */
        var tooltipID = this.tooltipID;
        /** @type {?} */
        var svg;
        /** @type {?} */
        var categories;
        if (options.xAxis && options.xAxis.categories) {
            categories = options.xAxis.categories;
        }
        else {
            /** @type {?} */
            var seriesData = options.series[0].data;
            categories = ((/** @type {?} */ (seriesData))).map((/**
             * @param {?} e
             * @return {?}
             */
            function (e) { return e.name; }));
        }
        // map data to D3 friendly format
        /** @type {?} */
        var data = bentoChartService.getD3Data(options, 'x');
        // save current state of bbox (for transition between data state)
        select(nativeEl)
            .selectAll('.col')
            .each((/**
         * @param {?} col
         * @param {?} colIndex
         * @return {?}
         */
        function (col, colIndex) {
            _self._currentRectBBox[colIndex] = [];
            /** @type {?} */
            var bar = select(this).selectAll('.bar');
            bar.each((/**
             * @param {?} d
             * @param {?} i
             * @return {?}
             */
            function (d, i) {
                /** @type {?} */
                var rect = this;
                _self._currentRectBBox[colIndex][i] = rect.getBBox();
            }));
        }));
        // save current state of middle axis for transition
        select(nativeEl)
            .select('.x.axis.middle')
            .each((/**
         * @param {?} d
         * @return {?}
         */
        function (d) {
            /** @type {?} */
            var rect = this;
            _self._currentMiddleXAxisBBox = rect.getBBox();
        }));
        // remove pre-existing svg
        select(nativeEl)
            .select('svg')
            .remove();
        // start fresh svg
        svg = select(nativeEl)
            .append('svg')
            .attr('width', '100%')
            .attr('height', currentOptions.chart.height + currentOptions.chart.marginTop + currentOptions.chart.marginBottom)
            .append('g');
        // Setup and Append Y Axis
        /** @type {?} */
        var y = scaleLinear();
        // get max value from data
        /** @type {?} */
        var maxValue = Number(max(options.series, (/**
         * @param {?} obj
         * @return {?}
         */
        function (obj) {
            // check if data is array of object or values, if object
            if (typeof obj.data[0] === 'object') {
                return max(obj.data, (/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) { return e.y; }));
            }
            else {
                return max(obj.data);
            }
        })));
        // get min value from data
        /** @type {?} */
        var minValue = Number(min(options.series, (/**
         * @param {?} obj
         * @return {?}
         */
        function (obj) {
            if (typeof obj.data[0] === 'object') {
                return min(obj.data, (/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) { return e.y; }));
            }
            else {
                return min(obj.data);
            }
        })));
        // include 0 in y axis and give some vertical padding
        minValue = minValue > 0 ? 0 : minValue + minValue * 0.1;
        maxValue = maxValue < 0 ? 0 : maxValue + maxValue * 0.1;
        /** @type {?} */
        var flatOptions = bentoChartService.flattenObject(currentOptions);
        if (flatOptions['colors']) {
            this.color = scaleOrdinal().range(currentOptions.colors);
        }
        /** @type {?} */
        var xAxis;
        // create group margin, if there are grouped columns, provide more margin
        // if there is only one set of columns, have smaller margins
        /** @type {?} */
        var colGroupMargin = data.length > 1 ? flatOptions['plotOptions.series.groupPadding'] : 0;
        /** @type {?} */
        var colMargin = flatOptions['plotOptions.series.pointPadding'] || 0.2;
        // Set up and Append X Axis
        /** @type {?} */
        var x0 = scaleBand()
            .range([0, currentOptions.chart.width])
            .padding(colGroupMargin)
            .round(true);
        // calculate the y-axis domain
        if (flatOptions['plotOptions.series.stacking'] || flatOptions['plotOptions.column.stacking']) {
            xAxis = axisBottom(x0);
            minValue = 0;
            maxValue = max(data, (/**
             * @param {?} d
             * @return {?}
             */
            function (d) { return Number(d.total); }));
            y.domain([minValue, maxValue])
                .nice()
                .range([currentOptions.chart.height, 0]);
        }
        else {
            y.domain([minValue, maxValue])
                .nice()
                .range([currentOptions.chart.height, 0]);
        }
        /** @type {?} */
        var yAxis = axisLeft(y);
        // check for custom yAxis label formatter
        if (flatOptions['yAxis.labels.formatter']) {
            yAxis.tickFormat(flatOptions['yAxis.labels.formatter']);
        }
        /** @type {?} */
        var yAxisContainer = svg
            .append('g')
            .attr('shape-rendering', 'crispEdges')
            .attr('class', 'y axis')
            .call(yAxis);
        // calc max y-axis Label Width
        /** @type {?} */
        var maxYAxisLabelWidth = 0;
        /** @type {?} */
        var yAxisText = yAxisContainer.selectAll('text');
        // apply styles to labels
        if (bentoChartService.checkNested(currentOptions, 'yAxis', 'labels', 'style')) {
            bentoChartService.applyStyle(yAxisText, currentOptions.yAxis.labels.style);
        }
        yAxisText.each((/**
         * @return {?}
         */
        function () {
            if (this.getBBox().width > maxYAxisLabelWidth) {
                maxYAxisLabelWidth = this.getBBox().width;
            }
        }));
        // check for y-axis title
        /** @type {?} */
        var yAxisTitle;
        if (flatOptions['yAxis.title.text']) {
            yAxisTitle = yAxisContainer
                .append('text')
                .attr('transform', 'rotate(-90)')
                .attr('x', -currentOptions.chart.height / 2)
                .style('text-anchor', 'middle')
                .text(flatOptions['yAxis.title.text']);
            maxYAxisLabelWidth = -maxYAxisLabelWidth - yAxisTitle.node().getBBox().height - 2;
            yAxisTitle.attr('dy', maxYAxisLabelWidth);
        }
        svg.attr('transform', 'translate(' + currentOptions.chart.marginLeft + ',' + currentOptions.chart.marginTop + ')');
        /** @type {?} */
        var x1 = scaleBand();
        // if grouped or stacked, use names,
        // else use categories for x-axis labels
        xAxis = data.length > 1 ? axisBottom(x0) : axisBottom(x1);
        if (flatOptions['xAxis.labels.formatter']) {
            xAxis.tickFormat(flatOptions['xAxis.labels.formatter']);
        }
        // set up x-axis domain
        x0.domain(data.map((/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return d.name; })));
        x1.domain(categories)
            .range([0, x0.bandwidth()])
            .padding(colMargin)
            .round(true);
        // x lines
        svg
            .selectAll('line.horizontal-grid')
            .data(y.ticks())
            .enter()
            .append('line')
            .attr('class', 'horizontal-grid')
            .attr('x1', 0)
            .attr('x2', currentOptions.chart.width)
            .attr('y1', (/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return y(d); }))
            .attr('y2', (/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return y(d); }))
            .style('stroke', '#000')
            .style('stroke-opacity', '0.1');
        // Append columns
        /** @type {?} */
        var colGroup = svg
            .selectAll('.col')
            .data(data)
            .enter()
            .append('g')
            .attr('class', 'col')
            .attr('transform', (/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return 'translate(' + x0(d.name) + ',0)'; }));
        /** @type {?} */
        var tooltipFormatter = flatOptions['tooltip.formatter'];
        /** @type {?} */
        var startColHeight = (/**
         * @param {?} d
         * @param {?} i
         * @param {?} _colIndex
         * @return {?}
         */
        function (d, i, _colIndex) {
            if (_self._hasInit && _self._currentRectBBox.length > 0 && _self._currentRectBBox[_colIndex][i]) {
                return _self._currentRectBBox[_colIndex][i].height;
            }
            else {
                return 0;
            }
        });
        /** @type {?} */
        var startColY = (/**
         * @param {?} d
         * @param {?} i
         * @param {?} _colIndex
         * @return {?}
         */
        function (d, i, _colIndex) {
            if (_self._hasInit && _self._currentRectBBox.length > 0 && _self._currentRectBBox[_colIndex][i]) {
                return _self._currentRectBBox[_colIndex][i].y;
            }
            else {
                return y(0);
            }
        });
        // Iterate through each columns group
        colGroup.each((/**
         * @param {?} _col
         * @param {?} _colIndex
         * @return {?}
         */
        function (_col, _colIndex) {
            var _this = this;
            /** @type {?} */
            var columnBars = select(this)
                .selectAll('.bar')
                .data((/**
             * @param {?} d
             * @return {?}
             */
            function (d) { return d.barData; }))
                .enter()
                .append('rect')
                .on('mouseover', (/**
             * @param {?} d
             * @return {?}
             */
            function (d) {
                bentoChartService.onMouseMove(d, this, nativeEl, tooltipID, tooltipFormatter);
            }))
                .on('mousemove', (/**
             * @param {?} d
             * @return {?}
             */
            function (d) {
                bentoChartService.onMouseMove(d, _this, nativeEl, tooltipID, tooltipFormatter);
            }))
                .on('mouseout', (/**
             * @return {?}
             */
            function () {
                bentoChartService.onMouseOut(tooltipID);
            }))
                .attr('class', 'bar');
            // if stacking option on
            if (flatOptions['plotOptions.series.stacking'] || flatOptions['plotOptions.column.stacking']) {
                columnBars
                    .attr('width', x0.bandwidth())
                    .attr('fill', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) { return d.color || _self.color(d.name); }))
                    .attr('height', (/**
                 * @param {?} d
                 * @param {?} i
                 * @return {?}
                 */
                function (d, i) { return startColHeight(d, i, _colIndex); }))
                    .attr('y', (/**
                 * @param {?} d
                 * @param {?} i
                 * @return {?}
                 */
                function (d, i) { return startColY(d, i, _colIndex); }))
                    .transition()
                    .duration(_self._duration)
                    .attr('height', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) { return y(d.y0) - y(d.y1); }))
                    .attr('y', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) { return y(d.y1); }));
            }
            else {
                columnBars
                    .attr('x', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) { return x1(d.name); }))
                    .attr('width', x1.bandwidth())
                    .attr('fill', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) { return d.color || _self.color(d.name); }))
                    .attr('height', (/**
                 * @param {?} d
                 * @param {?} i
                 * @return {?}
                 */
                function (d, i) { return startColHeight(d, i, _colIndex); }))
                    .attr('y', (/**
                 * @param {?} d
                 * @param {?} i
                 * @return {?}
                 */
                function (d, i) { return startColY(d, i, _colIndex); }))
                    .transition()
                    .duration(_self._duration)
                    .attr('y', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) { return (d.value < 0 ? y(0) : y(d.value)); }))
                    .attr('height', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) { return Math.abs(y(d.value) - y(0)); }));
            }
            columnBars
                .exit()
                .transition()
                .duration(300)
                .attr('height', 0)
                .remove();
        }));
        // show center divider xAxis if needed
        if (minValue !== 0) {
            /** @type {?} */
            var startMidX_1 = (/**
             * @param {?} d
             * @return {?}
             */
            function (d) {
                if (_self._hasInit && _self._currentMiddleXAxisBBox && _self._currentMiddleXAxisBBox.y) {
                    return _self._currentMiddleXAxisBBox.y;
                }
                else {
                    return y(0);
                }
            });
            svg
                .append('g')
                .append('line')
                .attr('class', 'x axis middle')
                .attr('y1', (/**
             * @param {?} d
             * @return {?}
             */
            function (d) { return startMidX_1(d); }))
                .attr('y2', (/**
             * @param {?} d
             * @return {?}
             */
            function (d) { return startMidX_1(d); }))
                .attr('x2', currentOptions.chart.width)
                .transition()
                .duration(_self._duration)
                .attr('y1', y(0))
                .attr('y2', y(0));
        }
        // Append x-axis after columns
        /** @type {?} */
        var xAxisContainer = svg
            .append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + currentOptions.chart.height + ')')
            .attr('shape-rendering', 'crispEdges')
            .call(xAxis);
        if (flatOptions['xAxis.labels.rotation']) {
            svg
                .selectAll('.x.axis text') // select all the text elements for the xaxis
                .attr('transform', (/**
             * @return {?}
             */
            function () {
                return ('translate(' +
                    this.getBBox().height * -0.5 +
                    ',' +
                    this.getBBox().height * 0.5 +
                    ')rotate(' +
                    flatOptions['xAxis.labels.rotation'] +
                    ' 0,0)');
            }))
                .style('text-anchor', 'end')
                .attr('x', 0)
                .attr('y', 0);
        }
        if (flatOptions['xAxis.labels.style.fontSize']) {
            svg.selectAll('.x.axis text').attr('font-size', flatOptions['xAxis.labels.style.fontSize']);
        }
        // calc max x-axis Label Height
        /** @type {?} */
        var maxXAxisLabelHeight = 0;
        /** @type {?} */
        var xAxisText = xAxisContainer.selectAll('text');
        if (flatOptions['xAxis.labels.style.fontSize']) {
            xAxisText.attr('font-size', flatOptions['xAxis.labels.style.fontSize']);
        }
        xAxisText.each((/**
         * @return {?}
         */
        function () {
            if (this.getBoundingClientRect().height > maxXAxisLabelHeight) {
                maxXAxisLabelHeight = this.getBoundingClientRect().height;
            }
        }));
        // check for x-axis title
        /** @type {?} */
        var xAxisTitle;
        if (flatOptions['xAxis.title.text']) {
            xAxisTitle = xAxisContainer
                .append('text')
                .attr('x', currentOptions.chart.width / 2)
                .style('text-anchor', 'middle')
                .text(flatOptions['xAxis.title.text']);
            maxXAxisLabelHeight = maxXAxisLabelHeight + xAxisTitle.node().getBoundingClientRect().height + 10;
            xAxisTitle.attr('dy', maxXAxisLabelHeight);
        }
        // if grouped columns, show legend
        /** @type {?} */
        var legend;
        if (flatOptions['legend.enabled'] !== false && data.length > 1) {
            if (flatOptions['plotOptions.series.stacking'] || flatOptions['plotOptions.column.stacking']) {
                legend = svg
                    .selectAll('.legend')
                    .data(categories.slice().reverse())
                    .enter()
                    .append('g');
            }
            else {
                legend = svg
                    .selectAll('.legend')
                    .data(categories.slice())
                    .enter()
                    .append('g');
            }
            legend.attr('class', 'legend').attr('transform', (/**
             * @param {?} d
             * @param {?} i
             * @return {?}
             */
            function (d, i) { return 'translate(0,' + i * 19 + ')'; }));
            legend
                .append('rect')
                .attr('x', currentOptions.chart.width - 15 + currentOptions.chart.marginRight)
                .attr('width', 15)
                .attr('height', 15)
                .style('fill', this.color);
            legend
                .append('text')
                .attr('x', currentOptions.chart.width - 21 + currentOptions.chart.marginRight)
                .attr('y', 9)
                .attr('dy', '.15em')
                .style('text-anchor', 'end')
                .text((/**
             * @param {?} d
             * @return {?}
             */
            function (d) { return d; }));
        }
        if (this.isRtl) {
            this.bentoChartService.makeRTL(nativeEl, svg, flatOptions, currentOptions, xAxisTitle, yAxisTitle, yAxisText, legend, maxXAxisLabelHeight, maxYAxisLabelWidth);
        }
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3ColumnChartComponent.prototype.flipDirection = /**
     * @private
     * @return {?}
     */
    function () {
        this.isRtl = this.dir.value === 'rtl';
        this._onResize();
    };
    /** @nocollapse */
    BentoD3ColumnChartComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoD3ColorService },
        { type: BentoD3ChartService },
        { type: BentoNotification },
        { type: Directionality }
    ]; };
    BentoD3ColumnChartComponent.propDecorators = {
        options: [{ type: Input }]
    };
BentoD3ColumnChartComponent.ɵfac = function BentoD3ColumnChartComponent_Factory(t) { return new (t || BentoD3ColumnChartComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoD3ColorService), ɵngcc0.ɵɵdirectiveInject(BentoD3ChartService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Directionality)); };
BentoD3ColumnChartComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoD3ColumnChartComponent, selectors: [["bento-d3-column-chart"]], inputs: { options: "options" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [[1, "bento-d3-tooltip", "top", "tooltip", 3, "id"], [1, "tooltip-arrow"], [1, "tooltip-inner"]], template: function BentoD3ColumnChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.tooltipID);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoD3ColumnChartComponent, [{
        type: Component,
        args: [{
                selector: 'bento-d3-column-chart',
                template: "<div [id]=\"tooltipID\" class=\"bento-d3-tooltip top tooltip\">\n  <div class=\"tooltip-arrow\"></div>\n  <div class=\"tooltip-inner\"></div>\n</div>\n",
                providers: [BentoNotification]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: BentoD3ColorService }, { type: BentoD3ChartService }, { type: ɵngcc1.BentoNotification }, { type: ɵngcc2.Directionality }]; }, { options: [{
            type: Input
        }] }); })();
    return BentoD3ColumnChartComponent;
}());
if (false) {
    /**
     * Column Chart Options - Please use the BentoChartOptions interface (see below API)
     * @type {?}
     */
    BentoD3ColumnChartComponent.prototype.options;
    /** @type {?} */
    BentoD3ColumnChartComponent.prototype.tooltipID;
    /**
     * @type {?}
     * @private
     */
    BentoD3ColumnChartComponent.prototype.isRtl;
    /**
     * @type {?}
     * @private
     */
    BentoD3ColumnChartComponent.prototype.nativeEl;
    /**
     * @type {?}
     * @private
     */
    BentoD3ColumnChartComponent.prototype.currentOptions;
    /**
     * @type {?}
     * @private
     */
    BentoD3ColumnChartComponent.prototype.color;
    /**
     * @type {?}
     * @private
     */
    BentoD3ColumnChartComponent.prototype._currentRectBBox;
    /**
     * @type {?}
     * @private
     */
    BentoD3ColumnChartComponent.prototype._currentMiddleXAxisBBox;
    /**
     * @type {?}
     * @private
     */
    BentoD3ColumnChartComponent.prototype._duration;
    /**
     * @type {?}
     * @private
     */
    BentoD3ColumnChartComponent.prototype._hasInit;
    /**
     * @type {?}
     * @private
     */
    BentoD3ColumnChartComponent.prototype.bentoColorService;
    /**
     * @type {?}
     * @private
     */
    BentoD3ColumnChartComponent.prototype.bentoChartService;
    /**
     * @type {?}
     * @private
     */
    BentoD3ColumnChartComponent.prototype.dir;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/line-chart/line-chart.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * #### Requires BentoD3Module from `\@bento/bento-ng-d3`
 * This is a Bento component for line charts built with
 * [D3](http://d3js.org/).
 *
 * **IMPORTANT:** Make sure to import `BentoD3Module` for this component to work:
 * ```typescript
 * import { BentoD3Module } from '\@bento/bento-ng-d3';
 * ```
 * For loading external CSV data in IE11, please also include the following polyfill:
 * https://github.com/matthew-andrews/isomorphic-fetch
 */
var BentoD3LineChartComponent = /** @class */ (function () {
    function BentoD3LineChartComponent(elRef, bentoColorService, bentoChartService, bentoNotification, dir) {
        var _this = this;
        this.bentoColorService = bentoColorService;
        this.bentoChartService = bentoChartService;
        this.dir = dir;
        this.tooltipID = this.bentoChartService.tooltipID();
        this.categories = [];
        this.xAxisCategories = [];
        this.tableIsShown = false;
        this.color = this.bentoColorService.line10();
        this._duration = 600;
        this._titlePad = 15;
        this.nativeEl = elRef.nativeElement;
        bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () { return _this._onResize(); }));
        this.isRtl = dir.value === 'rtl';
        dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.flipDirection();
        }));
    }
    /**
     * @return {?}
     */
    BentoD3LineChartComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.tooltip = select('#' + this.tooltipID);
        this.tooltipNode = this.nativeEl.querySelector('#' + this.tooltipID);
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this._updateData();
            _this._onResize();
        }));
    };
    /**
     * Call this method after updating data to refresh the visual representation
     */
    /**
     * Call this method after updating data to refresh the visual representation
     * @return {?}
     */
    BentoD3LineChartComponent.prototype.refresh = /**
     * Call this method after updating data to refresh the visual representation
     * @return {?}
     */
    function () {
        this.seriesData = null;
        this._updateData();
        this._onResize();
    };
    /**
     * Get the color of the line by passing in the index
     */
    /**
     * Get the color of the line by passing in the index
     * @param {?} i
     * @return {?}
     */
    BentoD3LineChartComponent.prototype.getColor = /**
     * Get the color of the line by passing in the index
     * @param {?} i
     * @return {?}
     */
    function (i) {
        /** @type {?} */
        var seriesColor;
        if (this.options.series && this.options.series[i]) {
            seriesColor = this.options.series[i].color;
        }
        return seriesColor || this.color(this.categories[i]);
    };
    /**
     * Toggle Table
     */
    /**
     * Toggle Table
     * @param {?=} isShown
     * @return {?}
     */
    BentoD3LineChartComponent.prototype.toggleDataTable = /**
     * Toggle Table
     * @param {?=} isShown
     * @return {?}
     */
    function (isShown) {
        this.tableIsShown = isShown != undefined ? isShown : !this.tableIsShown;
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3LineChartComponent.prototype._updateData = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var options = this.options;
        this.currentOptions = ((/** @type {?} */ (Object))).assign({}, this.bentoChartService.defaultOptions, this.options);
        this.flatOptions = this.bentoChartService.flattenObject(this.currentOptions);
        /** @type {?} */
        var parseDate = timeParse(this.flatOptions['xAxis.timeParse'] || '%Y-%m-%d');
        this._duration =
            this.flatOptions['plotOptions.line.animation.duration'] !== undefined
                ? this.flatOptions['plotOptions.line.animation.duration']
                : this._duration;
        this.tooltipFormatter = this.flatOptions['tooltip.formatter'];
        if (!this.seriesData) {
            if (options.series) {
                this.seriesData = options.series;
                /** @type {?} */
                var seriesLength_1 = 0;
                this.seriesData.forEach((/**
                 * @param {?} sData
                 * @return {?}
                 */
                function (sData) {
                    if (seriesLength_1 < sData.data.length) {
                        seriesLength_1 = sData.data.length;
                    }
                }));
                /** @type {?} */
                var pointStart = +this.flatOptions['plotOptions.series.pointStart'] || 0;
                /** @type {?} */
                var pointInterval = +this.flatOptions['plotOptions.series.pointInterval'] || 1;
                for (var i = 0; i < seriesLength_1; i++) {
                    this.xAxisCategories[i] = pointStart + i * pointInterval;
                }
            }
            else if (this.flatOptions['data.csvURL']) {
                csv(this.flatOptions['data.csvURL'], (/**
                 * @param {?} data
                 * @return {?}
                 */
                function (data) {
                    /** @type {?} */
                    var valueX = data[Object.keys(data)[0]];
                    if (_this.flatOptions['data.csvXAxisField']) {
                        valueX = data[_this.flatOptions['data.csvXAxisField']];
                    }
                    if (_this.flatOptions['xAxis.type'] === 'datetime') {
                        valueX = parseDate(valueX);
                    }
                    return __assign(__assign({}, data), { valueX: valueX });
                })).then((/**
                 * @param {?} data
                 * @return {?}
                 */
                function (data) {
                    /** @type {?} */
                    var yCategories = options.yAxis.categories;
                    _this.xAxisCategories = data.map((/**
                     * @param {?} item
                     * @return {?}
                     */
                    function (item) { return item.valueX; }));
                    if (yCategories && Array.isArray(yCategories)) {
                        _this.seriesData = [];
                        yCategories.forEach((/**
                         * @param {?} cat
                         * @param {?} i
                         * @return {?}
                         */
                        function (cat, i) {
                            if (!_this.seriesData[i]) {
                                _this.seriesData[i] = {
                                    data: [],
                                    name: cat
                                };
                            }
                            data.forEach((/**
                             * @param {?} item
                             * @return {?}
                             */
                            function (item) {
                                _this.seriesData[i].data.push(+item[cat]);
                            }));
                        }));
                    }
                    _this._onResize();
                }));
            }
        }
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3LineChartComponent.prototype._onResize = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.currentOptions && this.currentOptions.chart) {
            this.currentOptions.chart.width =
                this.nativeEl.offsetWidth - this.currentOptions.chart.marginLeft - this.currentOptions.chart.marginRight;
        }
        this._render();
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3LineChartComponent.prototype._render = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var _self = this;
        /** @type {?} */
        var bentoChartService = this.bentoChartService;
        /** @type {?} */
        var currentOptions = this.currentOptions;
        /** @type {?} */
        var nativeEl = this.nativeEl;
        /** @type {?} */
        var tooltipID = this.tooltipID;
        /** @type {?} */
        var tooltipLine;
        /** @type {?} */
        var svg;
        this.categories = [];
        // remove pre-existing svg
        select(nativeEl)
            .select('svg')
            .remove();
        // start fresh svg
        svg = select(nativeEl)
            .insert('svg', ':first-child')
            .attr('width', '100%')
            .attr('height', currentOptions.chart.height + currentOptions.chart.marginTop + currentOptions.chart.marginBottom)
            .append('g');
        // Setup and Append Y Axis
        /** @type {?} */
        var y = scaleLinear();
        // iterate through series of data
        /** @type {?} */
        var maxValue;
        // get max value from data
        /** @type {?} */
        var minValue;
        // get min value from data
        /** @type {?} */
        var seriesLength = 0;
        // get number of datapoints
        /** @type {?} */
        var minXValue;
        /** @type {?} */
        var maxXValue;
        if (this.seriesData) {
            this.seriesData.forEach((/**
             * @param {?} sData
             * @return {?}
             */
            function (sData) {
                if (seriesLength < sData.data.length) {
                    seriesLength = sData.data.length;
                }
                if (!maxValue || maxValue < max(sData.data)) {
                    maxValue = max(sData.data);
                }
                if (!minValue || minValue > min(sData.data)) {
                    minValue = min(sData.data);
                }
            }));
            minXValue = min(this.xAxisCategories);
            maxXValue = max(this.xAxisCategories);
        }
        // include 0 in y axis and give some vertical padding
        /** @type {?} */
        var yPadding = (Math.abs(minValue + maxValue) / 2) * 0.1;
        minValue = minValue - yPadding;
        maxValue = maxValue + yPadding;
        if (this.flatOptions['yAxis.min'] !== undefined) {
            minValue = this.flatOptions['yAxis.min'];
        }
        if (this.flatOptions['yAxis.max'] !== undefined) {
            maxValue = this.flatOptions['yAxis.max'];
        }
        /** @type {?} */
        var yScale = scaleLinear()
            .domain([minValue, maxValue]) // input
            .range([this.currentOptions.chart.height, 0]);
        // output
        /** @type {?} */
        var xScale;
        /** @type {?} */
        var line$1;
        if (this.flatOptions['xAxis.type'] === 'datetime') {
            xScale = scaleTime()
                .domain([minXValue, maxXValue]) // input
                .range([0, this.currentOptions.chart.width]); // output
            line$1 = line()
                .x((/**
             * @param {?} d
             * @param {?} i
             * @return {?}
             */
            function (d, i) { return xScale(_this.xAxisCategories[i]); })) // set the x values for the line generator
                .y((/**
             * @param {?} d
             * @return {?}
             */
            function (d) { return yScale(d['value']); })); // set the y values for the line generator
        }
        else {
            xScale = scaleLinear()
                .domain([minXValue, maxXValue]) // input
                .range([0, this.currentOptions.chart.width]); // output
            line$1 = line()
                .defined((/**
             * @param {?} d
             * @return {?}
             */
            function (d) { return d.value; }))
                .x((/**
             * @param {?} d
             * @param {?} i
             * @return {?}
             */
            function (d, i) { return xScale(_this.xAxisCategories[i]); })) // set the x values for the line generator
                .y((/**
             * @param {?} d
             * @return {?}
             */
            function (d) { return yScale(d.value); })); // set the y values for the line generator
        }
        // d3's line generator
        if (this.flatOptions['colors']) {
            this.color = scaleOrdinal().range(currentOptions.colors);
        }
        if (this.seriesData) {
            this.seriesData.forEach((/**
             * @param {?} sData
             * @param {?} sIndex
             * @return {?}
             */
            function (sData, sIndex) {
                _this.categories.push(sData.name);
                /** @type {?} */
                var dataset = ((/** @type {?} */ (sData.data))).map((/**
                 * @param {?} d
                 * @param {?} i
                 * @return {?}
                 */
                function (d, i) {
                    return {
                        value: d,
                        name: sData.name,
                        color: sData.color,
                        i: i,
                        valueX: _this.xAxisCategories[i]
                    };
                }));
                /** @type {?} */
                var tweenDash = (/**
                 * @return {?}
                 */
                function () {
                    /** @type {?} */
                    var l = this.getTotalLength();
                    /** @type {?} */
                    var i = interpolateString('0,' + l, l + ',' + l);
                    return (/**
                     * @param {?} t
                     * @return {?}
                     */
                    function (t) {
                        return i(t);
                    });
                });
                svg
                    .append('path')
                    .datum(dataset) // Binds data to the line
                    .attr('class', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) {
                    return 'line bento-chart-series-' + sIndex;
                })) // Assign a class for styling
                    .attr('d', line$1)
                    .attr('stroke', (/**
                 * @param {?} d
                 * @param {?} i
                 * @return {?}
                 */
                function (d, i) {
                    return d[i].color || _this.color(d[i].name);
                }))
                    .attr('stroke-width', (/**
                 * @param {?} d
                 * @return {?}
                 */
                function (d) { return _this.flatOptions['plotOptions.series.lineWidth'] || 2; }))
                    .transition()
                    .duration(_this._duration)
                    .attrTween('stroke-dasharray', tweenDash); // Calls the line generator
                if (_this.flatOptions['plotOptions.series.marker.enabled'] !== false) {
                    /** @type {?} */
                    var dotsDelay_1 = _this._duration / seriesLength;
                    svg
                        .selectAll('.dot-' + sIndex)
                        .data(dataset)
                        .enter()
                        .filter((/**
                     * @param {?} d
                     * @return {?}
                     */
                    function (d) { return d.value !== null; }))
                        .append('circle') // Uses the enter().append() method
                        .attr('class', 'dot-' + sIndex) // Assign a class for styling
                        .attr('cx', (/**
                     * @param {?} d
                     * @return {?}
                     */
                    function (d) { return xScale(d.valueX); }))
                        .attr('cy', (/**
                     * @param {?} d
                     * @return {?}
                     */
                    function (d) { return yScale(d.value); }))
                        .attr('r', 0)
                        .attr('fill', (/**
                     * @param {?} d
                     * @return {?}
                     */
                    function (d) { return d.color || _this.color(d.name); }))
                        .on('mouseover', (/**
                     * @param {?} d
                     * @return {?}
                     */
                    function (d) {
                        bentoChartService.onMouseMove(d, this, nativeEl, tooltipID, _self.tooltipFormatter, 'lineRegular', this.tooltip, this.tooltipNode);
                    }))
                        .on('mousemove', (/**
                     * @param {?} d
                     * @return {?}
                     */
                    function (d) {
                        bentoChartService.onMouseMove(d, this, nativeEl, tooltipID, _self.tooltipFormatter, 'lineRegular', this.tooltip, this.tooltipNode);
                    }))
                        .on('mouseout', (/**
                     * @return {?}
                     */
                    function () {
                        bentoChartService.onMouseOut(tooltipID);
                    }))
                        .transition()
                        .delay((/**
                     * @param {?} d
                     * @param {?} i
                     * @return {?}
                     */
                    function (d, i) { return dotsDelay_1 * i; }))
                        .duration(100)
                        .attr('r', (/**
                     * @param {?} d
                     * @return {?}
                     */
                    function (d) { return _this.flatOptions['plotOptions.series.marker.radius'] || 3; }))
                        .attr('stroke', (/**
                     * @param {?} d
                     * @return {?}
                     */
                    function (d) { return d.color || _this.color(d.name); }))
                        .attr('stroke-width', 2)
                        .attr('fill', '#ffffff');
                }
            }));
        }
        if (this.flatOptions['plotOptions.line.enableMouseTracking']) {
            tooltipLine = svg.append('line');
            svg
                .append('rect')
                .attr('x', 0)
                .attr('y', 0)
                .attr('width', currentOptions.chart.width)
                .attr('height', currentOptions.chart.height)
                .style('fill', 'transparent');
            svg
                .on('mouseover', (/**
             * @return {?}
             */
            function () {
                _self.drawTrackingTooltip(this, tooltipLine, xScale, _self.xAxisCategories);
            }))
                .on('mousemove', (/**
             * @return {?}
             */
            function () {
                _self.drawTrackingTooltip(this, tooltipLine, xScale, _self.xAxisCategories);
            }))
                .on('mouseout', (/**
             * @return {?}
             */
            function () {
                if (tooltipLine) {
                    tooltipLine.attr('class', '');
                }
                bentoChartService.onMouseOut(tooltipID);
            }));
        }
        // calculate the y-axis domain
        y.domain([minValue, maxValue]).range([currentOptions.chart.height, 0]);
        /** @type {?} */
        var yAxis = axisLeft(y);
        // check for custom yAxis label formatter
        if (this.flatOptions['yAxis.labels.formatter']) {
            yAxis.tickFormat(this.flatOptions['yAxis.labels.formatter']);
        }
        // y lines
        svg
            .selectAll('line.horizontal-grid')
            .data(y.ticks())
            .enter()
            .append('line')
            .attr('class', 'horizontal-grid')
            .attr('x1', 0)
            .attr('x2', currentOptions.chart.width)
            .attr('y1', (/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return y(d); }))
            .attr('y2', (/**
         * @param {?} d
         * @return {?}
         */
        function (d) { return y(d); }))
            .style('stroke', '#000')
            .style('stroke-opacity', '0.1');
        /** @type {?} */
        var totalTicks = seriesLength - 1;
        if (this.flatOptions['xAxis.tickInterval']) {
            totalTicks = seriesLength / +this.flatOptions['xAxis.tickInterval'];
        }
        /** @type {?} */
        var xAxis = axisBottom(xScale).ticks(totalTicks);
        if (this.flatOptions['xAxis.labels.formatter']) {
            xAxis.tickFormat(this.flatOptions['xAxis.labels.formatter']);
        }
        /** @type {?} */
        var xAxisContainer = svg
            .append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + this.currentOptions.chart.height + ')')
            .call(xAxis);
        if (this.flatOptions['xAxis.labels.rotation']) {
            svg
                .selectAll('.x.axis text') // select all the text elements for the xaxis
                .attr('transform', (/**
             * @return {?}
             */
            function () {
                return ('translate(' +
                    this.getBBox().height * -0.5 +
                    ',' +
                    this.getBBox().height * 0.5 +
                    ')rotate(' +
                    _self.flatOptions['xAxis.labels.rotation'] +
                    ' 0,0)');
            }))
                .style('text-anchor', 'end')
                .attr('x', 0)
                .attr('y', 0);
        }
        // check for x-axis title
        /** @type {?} */
        var xAxisTitle;
        /** @type {?} */
        var maxXAxisLabelHeight = 0;
        /** @type {?} */
        var xAxisText = xAxisContainer.selectAll('text');
        if (this.flatOptions['xAxis.labels.style.fontSize']) {
            xAxisText.attr('font-size', this.flatOptions['xAxis.labels.style.fontSize']);
        }
        xAxisText.each((/**
         * @return {?}
         */
        function () {
            if (this.getBoundingClientRect().height > maxXAxisLabelHeight) {
                maxXAxisLabelHeight = this.getBoundingClientRect().height;
            }
        }));
        if (this.flatOptions['xAxis.title.text']) {
            xAxisTitle = xAxisContainer
                .append('text')
                .attr('class', 'title')
                .attr('x', currentOptions.chart.width / 2)
                .style('text-anchor', 'middle')
                .text(this.flatOptions['xAxis.title.text']);
            maxXAxisLabelHeight = maxXAxisLabelHeight + xAxisTitle.node().getBoundingClientRect().height + this._titlePad;
            xAxisTitle.attr('dy', maxXAxisLabelHeight);
        }
        /** @type {?} */
        var yAxisContainer = svg
            .append('g')
            .attr('shape-rendering', 'crispEdges')
            .attr('class', 'y axis')
            .call(yAxis);
        // calc max y-axis Label Width
        /** @type {?} */
        var maxYAxisLabelWidth = 0;
        /** @type {?} */
        var yAxisText = yAxisContainer.selectAll('text');
        // apply styles to labels
        if (bentoChartService.checkNested(currentOptions, 'yAxis', 'labels', 'style')) {
            bentoChartService.applyStyle(yAxisText, currentOptions.yAxis.labels.style);
        }
        yAxisText.each((/**
         * @return {?}
         */
        function () {
            if (this.getBBox().width > maxYAxisLabelWidth) {
                maxYAxisLabelWidth = this.getBBox().width;
            }
        }));
        // check for y-axis title
        /** @type {?} */
        var yAxisTitle;
        if (this.flatOptions['yAxis.title.text']) {
            yAxisTitle = yAxisContainer
                .append('text')
                .attr('class', 'title')
                .attr('transform', 'rotate(-90)')
                .attr('x', -currentOptions.chart.height / 2)
                .style('text-anchor', 'middle')
                .text(this.flatOptions['yAxis.title.text']);
            maxYAxisLabelWidth = -maxYAxisLabelWidth - yAxisTitle.node().getBBox().height - this._titlePad;
            yAxisTitle.attr('dy', maxYAxisLabelWidth);
        }
        svg.attr('transform', 'translate(' + currentOptions.chart.marginLeft + ',' + currentOptions.chart.marginTop + ')');
        // Append x-axis after columns
        // show legend
        /** @type {?} */
        var legend;
        if (this.flatOptions['legend.enabled'] !== false && this.categories.length > 0) {
            /** @type {?} */
            var legendContainer = svg.append('g').attr('class', 'legend-group');
            /** @type {?} */
            var lineWidth = 24;
            legend = legendContainer
                .selectAll('.legend')
                .data(this.categories.slice())
                .enter()
                .append('g');
            legend.attr('class', 'legend').attr('transform', (/**
             * @param {?} d
             * @param {?} i
             * @return {?}
             */
            function (d, i) { return 'translate(0,' + i * 19 + ')'; }));
            legend
                .append('line')
                .attr('x1', 0)
                .attr('class', (/**
             * @param {?} d
             * @param {?} i
             * @return {?}
             */
            function (d, i) {
                return 'line bento-chart-series-' + i;
            }))
                .attr('y1', 0)
                .attr('x2', lineWidth)
                .attr('y2', 0)
                .attr('stroke-width', this.flatOptions['plotOptions.series.lineWidth'] || 2)
                .style('stroke', (/**
             * @param {?} d
             * @param {?} i
             * @return {?}
             */
            function (d, i) {
                /** @type {?} */
                var seriesColor;
                if (_this.options.series && _this.options.series[i]) {
                    seriesColor = _this.options.series[i].color;
                }
                return seriesColor || _this.color(d);
            }));
            if (this.flatOptions['plotOptions.series.marker.enabled'] !== false) {
                legend
                    .append('circle') // Uses the enter().append() method
                    .attr('cx', lineWidth / 2)
                    .attr('cy', 0)
                    .attr('r', this.flatOptions['plotOptions.series.marker.radius'] || 3)
                    .style('stroke', (/**
                 * @param {?} d
                 * @param {?} i
                 * @return {?}
                 */
                function (d, i) {
                    /** @type {?} */
                    var seriesColor;
                    if (_this.options.series && _this.options.series[i]) {
                        seriesColor = _this.options.series[i].color;
                    }
                    return seriesColor || _this.color(d);
                }))
                    .attr('stroke-width', 2)
                    .attr('fill', '#ffffff');
            }
            legend
                .append('text')
                .attr('x', lineWidth + 5)
                .attr('y', 1)
                .attr('dy', '.15em')
                .style('text-anchor', 'start')
                .text((/**
             * @param {?} d
             * @return {?}
             */
            function (d) { return d; }));
            /** @type {?} */
            var legendWidth_1 = legendContainer.node().getBBox().width;
            legendContainer.attr('transform', (/**
             * @param {?} d
             * @param {?} i
             * @return {?}
             */
            function (d, i) { return 'translate(' + (+currentOptions.chart.width - legendWidth_1 + +currentOptions.chart.marginRight) + ',0)'; }));
        }
        if (this.isRtl) {
            this.bentoChartService.makeRTL(nativeEl, svg, this.flatOptions, currentOptions, xAxisTitle, yAxisTitle, yAxisText, legend, maxXAxisLabelHeight, maxYAxisLabelWidth);
        }
    };
    /**
     * @private
     * @param {?} node
     * @param {?} tooltipLine
     * @param {?} x
     * @param {?} categories
     * @return {?}
     */
    BentoD3LineChartComponent.prototype.drawTrackingTooltip = /**
     * @private
     * @param {?} node
     * @param {?} tooltipLine
     * @param {?} x
     * @param {?} categories
     * @return {?}
     */
    function (node, tooltipLine, x, categories) {
        var _this = this;
        // get xAxis value
        /** @type {?} */
        var xValue = x.invert(mouse(node)[0]);
        xValue = categories.find((/**
         * @param {?} h
         * @return {?}
         */
        function (h) { return h > xValue; }));
        // get nearest index of x axis category
        /** @type {?} */
        var xIndex = categories.indexOf(xValue);
        /** @type {?} */
        var tooltipObj = {
            valueX: xValue,
            series: []
        };
        if (this.seriesData) {
            this.seriesData.forEach((/**
             * @param {?} sData
             * @param {?} i
             * @return {?}
             */
            function (sData, i) {
                tooltipObj.series[i] = {
                    name: sData.name,
                    data: sData.data[xIndex],
                    color: sData.color || _this.color(sData.name)
                };
            }));
        }
        tooltipLine
            .attr('class', 'tooltip-line')
            .attr('x1', x(xValue))
            .attr('x2', x(xValue))
            .attr('y1', 0)
            .attr('y2', this.currentOptions.chart.height);
        this.bentoChartService.onMouseMove(tooltipObj, node, this.nativeEl, this.tooltipID, this.tooltipFormatter, 'lineTracking', this.tooltip, this.tooltipNode);
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3LineChartComponent.prototype.flipDirection = /**
     * @private
     * @return {?}
     */
    function () {
        this.isRtl = this.dir.value === 'rtl';
        this._onResize();
    };
    /** @nocollapse */
    BentoD3LineChartComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoD3ColorService },
        { type: BentoD3ChartService },
        { type: BentoNotification },
        { type: Directionality }
    ]; };
    BentoD3LineChartComponent.propDecorators = {
        options: [{ type: Input }]
    };
BentoD3LineChartComponent.ɵfac = function BentoD3LineChartComponent_Factory(t) { return new (t || BentoD3LineChartComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoD3ColorService), ɵngcc0.ɵɵdirectiveInject(BentoD3ChartService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Directionality)); };
BentoD3LineChartComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoD3LineChartComponent, selectors: [["bento-d3-line-chart"]], inputs: { options: "options" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification])], decls: 5, vars: 2, consts: [[1, "bento-d3-tooltip", "top", "tooltip", 3, "id"], [1, "tooltip-arrow"], [1, "tooltip-inner"], [1, "bento-chart-table-container"], ["class", "bento-chart-table", 4, "ngIf"], [1, "bento-chart-table"], ["scope", "col", "class", "text", 4, "ngIf"], [4, "ngIf"], ["scope", "col", "class", "text", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], ["scope", "col", 1, "text"], ["scope", "row", 1, "number"], ["class", "number", 4, "ngFor", "ngForOf"], [1, "number"]], template: function BentoD3LineChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtemplate(4, BentoD3LineChartComponent_table_4_Template, 8, 4, "table", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.tooltipID);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tableIsShown && ctx.xAxisCategories);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgForOf], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoD3LineChartComponent, [{
        type: Component,
        args: [{
                selector: 'bento-d3-line-chart',
                template: "<div [id]=\"tooltipID\" class=\"bento-d3-tooltip top tooltip\">\n  <div class=\"tooltip-arrow\"></div>\n  <div class=\"tooltip-inner\"></div>\n</div>\n<div class=\"bento-chart-table-container\">\n  <table *ngIf=\"tableIsShown && xAxisCategories\" class=\"bento-chart-table\">\n    <thead>\n      <tr>\n        <th *ngIf=\"this.flatOptions['xAxis.title.text']\" scope=\"col\" class=\"text\">\n          {{ this.flatOptions['xAxis.title.text'] }}\n        </th>\n        <td *ngIf=\"!this.flatOptions['xAxis.title.text']\"></td>\n        <th *ngFor=\"let item of categories\" scope=\"col\" class=\"text\">{{ item }}</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr *ngFor=\"let xAxis of xAxisCategories; let seriesId = index\">\n        <th scope=\"row\" class=\"number\">{{ xAxis }}</th>\n        <td *ngFor=\"let item of categories; let i = index\" class=\"number\">{{ seriesData[i].data[seriesId] }}</td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n",
                providers: [BentoNotification]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: BentoD3ColorService }, { type: BentoD3ChartService }, { type: ɵngcc1.BentoNotification }, { type: ɵngcc2.Directionality }]; }, { options: [{
            type: Input
        }] }); })();
    return BentoD3LineChartComponent;
}());
if (false) {
    /**
     * Line Chart Options - Please use the BentoChartOptions interface (see below API)
     * @type {?}
     */
    BentoD3LineChartComponent.prototype.options;
    /** @type {?} */
    BentoD3LineChartComponent.prototype.tooltipID;
    /** @type {?} */
    BentoD3LineChartComponent.prototype.categories;
    /** @type {?} */
    BentoD3LineChartComponent.prototype.xAxisCategories;
    /** @type {?} */
    BentoD3LineChartComponent.prototype.seriesData;
    /** @type {?} */
    BentoD3LineChartComponent.prototype.tableIsShown;
    /** @type {?} */
    BentoD3LineChartComponent.prototype.flatOptions;
    /**
     * @type {?}
     * @private
     */
    BentoD3LineChartComponent.prototype.tooltip;
    /**
     * @type {?}
     * @private
     */
    BentoD3LineChartComponent.prototype.tooltipNode;
    /**
     * @type {?}
     * @private
     */
    BentoD3LineChartComponent.prototype.isRtl;
    /**
     * @type {?}
     * @private
     */
    BentoD3LineChartComponent.prototype.nativeEl;
    /**
     * @type {?}
     * @private
     */
    BentoD3LineChartComponent.prototype.currentOptions;
    /**
     * @type {?}
     * @private
     */
    BentoD3LineChartComponent.prototype.color;
    /**
     * @type {?}
     * @private
     */
    BentoD3LineChartComponent.prototype._duration;
    /**
     * @type {?}
     * @private
     */
    BentoD3LineChartComponent.prototype._titlePad;
    /**
     * @type {?}
     * @private
     */
    BentoD3LineChartComponent.prototype.tooltipFormatter;
    /**
     * @type {?}
     * @private
     */
    BentoD3LineChartComponent.prototype.bentoColorService;
    /**
     * @type {?}
     * @private
     */
    BentoD3LineChartComponent.prototype.bentoChartService;
    /**
     * @type {?}
     * @private
     */
    BentoD3LineChartComponent.prototype.dir;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/arc-gauge/arc-gauge.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * #### Requires BentoD3Module from `\@bento/bento-ng-d3`
 * This component is known as the
 * [Percent Arc](http://bento.ui.int.thomsonreuters.com/#/components/percent-arc)
 * in Bento.UI 1.x.
 * This is an amount-completed indicator built with [D3](http://d3js.org/).
 * It can also be used as a realtime loading indicator. The last Arc Gauge in
 * this demo shows an alternative display of value rather than percentage.
 * Please see the Data API for usage.
 *
 * Be sure to provide a `height` via CSS to the Arc Gauge component or its
 * container.
 *
 * **IMPORTANT:** Make sure to import `BentoD3Module` for this component to work:
 * ```typescript
 * import { BentoD3Module } from '\@bento/bento-ng-d3';
 * ```
 */
var BentoD3ArcGaugeComponent = /** @class */ (function () {
    function BentoD3ArcGaugeComponent(elRef, bentoColorService, bentoChartService, bentoNotification) {
        var _this = this;
        this.bentoColorService = bentoColorService;
        this.bentoChartService = bentoChartService;
        this.tooltipID = this.bentoChartService.tooltipID();
        this.color = this.bentoColorService.brand10();
        this._hasInit = false;
        this._duration = 800;
        this._lastAngle = 0;
        this._lastValue = 0;
        this.nativeEl = elRef.nativeElement;
        bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () { return _this._onResize(); }));
    }
    /**
     * @return {?}
     */
    BentoD3ArcGaugeComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        if (this._hasInit) {
            this._onResize();
        }
    };
    /**
     * @return {?}
     */
    BentoD3ArcGaugeComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.refresh();
        this._hasInit = true;
    };
    /**
     * @return {?}
     */
    BentoD3ArcGaugeComponent.prototype.refresh = /**
     * @return {?}
     */
    function () {
        this._onResize();
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3ArcGaugeComponent.prototype._render = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var _self = this;
        /** @type {?} */
        var data = this.options.series[0].data[0];
        /** @type {?} */
        var subLabel = undefined;
        // not used
        /** @type {?} */
        var width = this.nativeEl.offsetHeight || 80;
        /** @type {?} */
        var pi = 2 * Math.PI;
        /** @type {?} */
        var arc$1 = arc()
            .innerRadius(0.9 * width * 0.5)
            .outerRadius(width * 0.5)
            .startAngle(0);
        /** @type {?} */
        var fontsize = (28 * width) / 100;
        /** @type {?} */
        var color = this.color(0);
        /** @type {?} */
        var fillColor = '#ddd';
        /** @type {?} */
        var flatOptions = this.bentoChartService.flattenObject(this.options);
        /** @type {?} */
        var stops = flatOptions['stops'] ? _self.options.stops : undefined;
        /** @type {?} */
        var domainArr = [];
        /** @type {?} */
        var rangeArr = [];
        // if color stops
        if (stops) {
            stops.forEach((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                domainArr.push(item[0]);
                rangeArr.push(item[1]);
            }));
        }
        select(this.nativeEl)
            .select('svg')
            .remove();
        /** @type {?} */
        var svg = select(this.nativeEl)
            .append('svg')
            .attr('width', width)
            .attr('height', width)
            .append('g')
            .attr('transform', 'translate(' + width / 2 + ',' + width / 2 + ')');
        /**
         * @param {?} transition
         * @param {?} angle
         * @return {?}
         */
        function arcTween(transition, angle) {
            transition.attrTween('d', (/**
             * @param {?} d
             * @return {?}
             */
            function (d) {
                /** @type {?} */
                var interpolate$1 = interpolate(d.endAngle, angle);
                return (/**
                 * @param {?} t
                 * @return {?}
                 */
                function (t) {
                    d.endAngle = interpolate$1(t);
                    /** @type {?} */
                    var percent = d.endAngle / pi;
                    arcPath.style('fill', (/**
                     * @return {?}
                     */
                    function () { return getArcColor(percent); }));
                    return arc$1(d);
                });
            }));
        }
        /** @type {?} */
        var getArcColor = (/**
         * @param {?} percent
         * @return {?}
         */
        function (percent) {
            /** @type {?} */
            var _color = flatOptions['minColor'] || flatOptions['maxColor'] || color;
            if (flatOptions['minColor'] && flatOptions['maxColor']) {
                /** @type {?} */
                var colorRamp = scaleLinear()
                    .domain([0, 0.5, 1])
                    .range([flatOptions['minColor'], '#ff0000', flatOptions['maxColor']]);
                _color = colorRamp(percent);
            }
            if (flatOptions['stops']) {
                /** @type {?} */
                var colorRamp = scaleLinear()
                    .domain(domainArr)
                    .range(rangeArr);
                _color = colorRamp(percent);
            }
            return _color;
        });
        if (data === undefined) {
            return;
        }
        // background
        svg
            .append('path')
            .datum({
            endAngle: pi
        })
            .style('fill', fillColor)
            .attr('d', arc$1);
        // foreground
        /** @type {?} */
        var arcPath = svg.append('path');
        arcPath
            .datum({
            endAngle: _self._lastAngle
        })
            // .style('fill', ()=>{ return getArcColor(data)})
            .attr('d', arc$1)
            .transition()
            .duration(_self._duration)
            .call(arcTween, parseInt(data, 10) * 0.01 * pi);
        /** @type {?} */
        var startVal = _self._lastValue;
        /** @type {?} */
        var currentVal = _self._lastValue;
        /** @type {?} */
        var endVal = [parseInt(data, 10)];
        /** @type {?} */
        var arcText = svg
            .selectAll('.number-label')
            .data(endVal)
            .enter()
            .append('text');
        arcText
            .text(startVal)
            .attr('class', 'number-label')
            // .attr('fill', color)
            .attr('y', fontsize * 0.3)
            .attr('x', 0)
            .style('font-size', fontsize + 'px')
            .attr('text-anchor', 'middle')
            .transition()
            .duration(_self._duration)
            .tween('text', (/**
         * @param {?} d
         * @return {?}
         */
        function (d) {
            /** @type {?} */
            var i = interpolate(currentVal, d);
            /** @type {?} */
            var _textEl = this;
            return (/**
             * @param {?} t
             * @return {?}
             */
            function (t) {
                /** @type {?} */
                var currentT = Math.round(i(t));
                currentVal = currentT + '%';
                // if formatting available, apply it
                if (flatOptions['dataLabels.formatter']) {
                    /** @type {?} */
                    var formatObj = {
                        percent: currentT,
                        color: getArcColor(currentT / 100)
                    };
                    currentVal = flatOptions['dataLabels.formatter'](formatObj);
                }
                // arcText.attr('fill', () => getArcColor(currentT / 100));
                _textEl.textContent = currentVal;
            });
        }));
        if (subLabel) {
            svg.selectAll('.number-label').attr('y', fontsize * 0.1);
            svg
                .append('text')
                .attr('y', fontsize * 0.7)
                .attr('x', 0)
                .attr('fill', color)
                .style('font-size', fontsize * 0.5 + 'px')
                .attr('text-anchor', 'middle')
                .attr('class', 'sub-label')
                .text(subLabel);
        }
        _self._lastAngle = parseInt(data, 10) * 0.01 * pi;
        _self._lastValue = parseInt(data, 10);
    };
    /**
     * @private
     * @return {?}
     */
    BentoD3ArcGaugeComponent.prototype._onResize = /**
     * @private
     * @return {?}
     */
    function () {
        this._render();
    };
    /** @nocollapse */
    BentoD3ArcGaugeComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoD3ColorService },
        { type: BentoD3ChartService },
        { type: BentoNotification }
    ]; };
    BentoD3ArcGaugeComponent.propDecorators = {
        options: [{ type: Input }]
    };
BentoD3ArcGaugeComponent.ɵfac = function BentoD3ArcGaugeComponent_Factory(t) { return new (t || BentoD3ArcGaugeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoD3ColorService), ɵngcc0.ɵɵdirectiveInject(BentoD3ChartService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BentoNotification)); };
BentoD3ArcGaugeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoD3ArcGaugeComponent, selectors: [["bento-d3-arc-gauge"]], inputs: { options: "options" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification]), ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0, decls: 1, vars: 0, template: function BentoD3ArcGaugeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoD3ArcGaugeComponent, [{
        type: Component,
        args: [{
                selector: 'bento-d3-arc-gauge',
                template: "\n    <ng-content></ng-content>\n  ",
                providers: [BentoNotification]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: BentoD3ColorService }, { type: BentoD3ChartService }, { type: ɵngcc1.BentoNotification }]; }, { options: [{
            type: Input
        }] }); })();
    return BentoD3ArcGaugeComponent;
}());
if (false) {
    /**
     * Please see BentoArcGaugeOptions for setting properties
     * @type {?}
     */
    BentoD3ArcGaugeComponent.prototype.options;
    /** @type {?} */
    BentoD3ArcGaugeComponent.prototype.tooltipID;
    /**
     * @type {?}
     * @private
     */
    BentoD3ArcGaugeComponent.prototype.nativeEl;
    /**
     * @type {?}
     * @private
     */
    BentoD3ArcGaugeComponent.prototype.color;
    /**
     * @type {?}
     * @private
     */
    BentoD3ArcGaugeComponent.prototype._hasInit;
    /**
     * @type {?}
     * @private
     */
    BentoD3ArcGaugeComponent.prototype._duration;
    /**
     * @type {?}
     * @private
     */
    BentoD3ArcGaugeComponent.prototype._lastAngle;
    /**
     * @type {?}
     * @private
     */
    BentoD3ArcGaugeComponent.prototype._lastValue;
    /**
     * @type {?}
     * @private
     */
    BentoD3ArcGaugeComponent.prototype.bentoColorService;
    /**
     * @type {?}
     * @private
     */
    BentoD3ArcGaugeComponent.prototype.bentoChartService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/interfaces/chart.interface.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The actual series data to append to the chart
 * @record
 */
function BentoChartData() { }
if (false) {
    /**
     * axis label
     * @type {?|undefined}
     */
    BentoChartData.prototype.name;
    /**
     * optional way of setting bar color, use hex values e.g. #ff0000
     * @type {?|undefined}
     */
    BentoChartData.prototype.color;
    /**
     * data value required for bar charts only
     * @type {?|undefined}
     */
    BentoChartData.prototype.x;
    /**
     * data value required for column charts only
     * @type {?|undefined}
     */
    BentoChartData.prototype.y;
}
/**
 * @record
 */
function BentoChartSeriesOptions() { }
if (false) {
    /**
     * use for axis label when in grouped or stacked chart mode
     * @type {?|undefined}
     */
    BentoChartSeriesOptions.prototype.name;
    /**
     * The actual series data to append to the chart
     * @type {?}
     */
    BentoChartSeriesOptions.prototype.data;
    /**
     * Optional way of setting line chart color
     * @type {?|undefined}
     */
    BentoChartSeriesOptions.prototype.color;
}
/**
 * Options regarding the chart area and plot area as well as general chart options.
 * @record
 */
function BentoChartCoreOptions() { }
if (false) {
    /**
     * The margin between the top outer edge of the chart and the
     * plot area. Use this to set a fixed pixel value for the margin
     * @type {?|undefined}
     */
    BentoChartCoreOptions.prototype.marginTop;
    /**
     * The margin between the right outer edge of the chart and the plot area.
     * @type {?|undefined}
     */
    BentoChartCoreOptions.prototype.marginRight;
    /**
     * The margin between the right outer edge of the chart and the plot area.
     * @type {?|undefined}
     */
    BentoChartCoreOptions.prototype.marginBottom;
    /**
     * The margin between the bottom outer edge of the chart and the plot area.
     * @type {?|undefined}
     */
    BentoChartCoreOptions.prototype.marginLeft;
    /**
     * An explicit height for the chart. The height is given in pixels. This allows for preserving the aspect ratio
     * across responsive sizes.
     * @type {?|undefined}
     */
    BentoChartCoreOptions.prototype.height;
    /** @type {?|undefined} */
    BentoChartCoreOptions.prototype.width;
}
/**
 * @record
 */
function BentoChartAxisOptions() { }
if (false) {
    /**
     * The axis labels show the number or category for each tick.
     * @type {?|undefined}
     */
    BentoChartAxisOptions.prototype.labels;
    /**
     * The axis title, showing next to the axis line.
     * @type {?|undefined}
     */
    BentoChartAxisOptions.prototype.title;
    /**
     * optional way of setting category array, useful for grouped and stacked data
     * @type {?|undefined}
     */
    BentoChartAxisOptions.prototype.categories;
    /**
     * minimum y axis value (line chart only)
     * @type {?|undefined}
     */
    BentoChartAxisOptions.prototype.min;
    /**
     * maximum y axis value (line chart only)
     * @type {?|undefined}
     */
    BentoChartAxisOptions.prototype.max;
}
/**
 * The axis labels show the number or category for each tick.
 * @record
 */
function BentoChartAxisLabelsOptions() { }
if (false) {
    /**
     * CSS styles for the label. Use camelCase for style property names.
     * e.g. "{fontSize: 13px; fill: #ff0000;}"
     * @type {?|undefined}
     */
    BentoChartAxisLabelsOptions.prototype.style;
    /**
     * set degrees of rotation for labels, useful when labels do not fit widthwise (typical value would be -45)
     * @type {?|undefined}
     */
    BentoChartAxisLabelsOptions.prototype.rotation;
    /**
     * function to customize y-axis labels format with tick value as function argument
     * @param {?} d
     * @return {?}
     */
    BentoChartAxisLabelsOptions.prototype.formatter = function (d) { };
}
/**
 * The axis title, showing next to the axis line.
 * @record
 */
function BentoChartAxisTitleOptions() { }
if (false) {
    /**
     * The actual text of the axis title.
     * @type {?}
     */
    BentoChartAxisTitleOptions.prototype.text;
}
/**
 * The plotOptions is a wrapper object for config objects for each series type.
 * @record
 */
function BentoChartPlotOptions() { }
if (false) {
    /**
     * General options for line chart
     * @type {?|undefined}
     */
    BentoChartPlotOptions.prototype.line;
    /**
     * General options for all series types.
     * @type {?}
     */
    BentoChartPlotOptions.prototype.series;
}
/**
 * General options for all series types.
 * @record
 */
function BentoChartPlotSeriesOptions() { }
if (false) {
    /**
     * the space between a column or bar (percentage of bar width)
     * @type {?|undefined}
     */
    BentoChartPlotSeriesOptions.prototype.pointPadding;
    /**
     * The space between a column group or stacked bar (percentage of group width)
     * @type {?|undefined}
     */
    BentoChartPlotSeriesOptions.prototype.groupPadding;
    /**
     * set value "normal" for stacking column chart
     * @type {?|undefined}
     */
    BentoChartPlotSeriesOptions.prototype.stacking;
    /**
     * start value of line chart
     * @type {?|undefined}
     */
    BentoChartPlotSeriesOptions.prototype.pointStart;
    /**
     * interval of xAxis value of line chart, starting from pointStart
     * @type {?|undefined}
     */
    BentoChartPlotSeriesOptions.prototype.pointInterval;
    /**
     * line chart marker options
     * @type {?|undefined}
     */
    BentoChartPlotSeriesOptions.prototype.marker;
    /**
     * line chart line width
     * @type {?|undefined}
     */
    BentoChartPlotSeriesOptions.prototype.lineWidth;
}
/**
 * General options for line chart
 * @record
 */
function BentoChartLineOptions() { }
if (false) {
    /**
     * allow for tooltips to follow mouse
     * @type {?|undefined}
     */
    BentoChartLineOptions.prototype.enableMouseTracking;
}
/**
 * Options for the line chart marker.
 * @record
 */
function BentoChartMarkerOptions() { }
if (false) {
    /**
     * radius of marker
     * @type {?|undefined}
     */
    BentoChartMarkerOptions.prototype.radius;
}
/**
 * Options for the tooltip that appears when the user hovers over a series.
 * @record
 */
function BentoChartTooltipOptions() { }
if (false) {
    /**
     * Data item gets passed in, and returns a html template string
     * @param {?} d
     * @return {?}
     */
    BentoChartTooltipOptions.prototype.formatter = function (d) { };
}
/**
 * The legend is a box containing a symbol and name for each series item in the chart. Each series is represented by a
 * symbol and its name in the legend.
 * @record
 */
function BentoChartLegendOptions() { }
if (false) {
    /**
     * Display or hide legend
     * @type {?|undefined}
     */
    BentoChartLegendOptions.prototype.enabled;
}
/**
 * Chart Options
 * @record
 */
function BentoChartOptions() { }
if (false) {
    /**
     * Options regarding the chart area and plot area as well as general chart options.
     * @type {?|undefined}
     */
    BentoChartOptions.prototype.chart;
    /**
     * The X axis or category axis.
     * @type {?|undefined}
     */
    BentoChartOptions.prototype.xAxis;
    /**
     * The Y axis or value axis.
     * @type {?|undefined}
     */
    BentoChartOptions.prototype.yAxis;
    /**
     * The plotOptions is a wrapper object for config objects for each series type.
     * @type {?|undefined}
     */
    BentoChartOptions.prototype.plotOptions;
    /**
     * The actual series to append to the chart
     * @type {?}
     */
    BentoChartOptions.prototype.series;
    /**
     * Options for the tooltip that appears when the user hovers over a series.
     * @type {?|undefined}
     */
    BentoChartOptions.prototype.tooltip;
    /**
     * The legend is a box containing a symbol and name for each series item in the chart. Each series is represented by
     * a symbol and its name in the legend.
     * @type {?|undefined}
     */
    BentoChartOptions.prototype.legend;
    /**
     * Override default colors array
     * @type {?|undefined}
     */
    BentoChartOptions.prototype.colors;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/interfaces/arc.interface.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Arc Gauge Options
 * @record
 */
function BentoArcGaugeOptions() { }
if (false) {
    /**
     * Format center label of guage
     * @type {?|undefined}
     */
    BentoArcGaugeOptions.prototype.dataLabels;
    /**
     * Array of percentage of 1 and hex color strings for color stops,
     * e.g.
     * `[[0.0, '#45b7e7'],
     *  [0.5, '#77a22d'],
     *  [1.0, '#dc0a0a']]`
     * @type {?|undefined}
     */
    BentoArcGaugeOptions.prototype.stops;
    /**
     * array of series options, currently only supports one array item
     * @type {?}
     */
    BentoArcGaugeOptions.prototype.series;
}
/**
 * Input data and adjust dimensions
 * @record
 */
function BentoArcGaugeSeriesOptions() { }
if (false) {
    /**
     * Outside diameter of guage in percentage of 1
     * @type {?|undefined}
     */
    BentoArcGaugeSeriesOptions.prototype.size;
    /**
     * Inside diameter of guage in percentage of 1
     * @type {?|undefined}
     */
    BentoArcGaugeSeriesOptions.prototype.innerSize;
    /**
     * array of numbers that are a percentage of 100,
     * currently supports only one array item
     * @type {?}
     */
    BentoArcGaugeSeriesOptions.prototype.data;
}
/**
 * Format center label of guage
 * @record
 */
function BentoArcGaugeLabelOptions() { }
if (false) {
    /**
     * function to customize labels
     * @param {?} d
     * @return {?}
     */
    BentoArcGaugeLabelOptions.prototype.formatter = function (d) { };
}
/**
 * Object returned to formatter
 * @record
 */
function BentoArcGaugeLabelFormatterObj() { }
if (false) {
    /**
     * percentage of 100
     * @type {?}
     */
    BentoArcGaugeLabelFormatterObj.prototype.percent;
    /**
     * current hex value of gauge
     * @type {?}
     */
    BentoArcGaugeLabelFormatterObj.prototype.color;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/arc-gauge/arc-gauge.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoArcGaugeModule = /** @class */ (function () {
    function BentoArcGaugeModule() {
    }
BentoArcGaugeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoArcGaugeModule });
BentoArcGaugeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoArcGaugeModule_Factory(t) { return new (t || BentoArcGaugeModule)(); }, providers: [BentoD3ChartService, BentoD3ColorService] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoArcGaugeModule, { declarations: [BentoD3ArcGaugeComponent], exports: [BentoD3ArcGaugeComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoArcGaugeModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoD3ArcGaugeComponent],
                providers: [BentoD3ChartService, BentoD3ColorService],
                exports: [BentoD3ArcGaugeComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoArcGaugeModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/bar-chart/bar-chart.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoBarChartModule = /** @class */ (function () {
    function BentoBarChartModule() {
    }
BentoBarChartModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoBarChartModule });
BentoBarChartModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoBarChartModule_Factory(t) { return new (t || BentoBarChartModule)(); }, providers: [BentoD3ChartService, BentoD3ColorService] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoBarChartModule, { declarations: [BentoD3BarChartComponent], exports: [BentoD3BarChartComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoBarChartModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoD3BarChartComponent],
                providers: [BentoD3ChartService, BentoD3ColorService],
                exports: [BentoD3BarChartComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoBarChartModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/column-chart/column-chart.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoColumnChartModule = /** @class */ (function () {
    function BentoColumnChartModule() {
    }
BentoColumnChartModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoColumnChartModule });
BentoColumnChartModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoColumnChartModule_Factory(t) { return new (t || BentoColumnChartModule)(); }, providers: [BentoD3ChartService, BentoD3ColorService] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoColumnChartModule, { declarations: [BentoD3ColumnChartComponent], exports: [BentoD3ColumnChartComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoColumnChartModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoD3ColumnChartComponent],
                providers: [BentoD3ChartService, BentoD3ColorService],
                exports: [BentoD3ColumnChartComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoColumnChartModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/line-chart/line-chart.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoLineChartModule = /** @class */ (function () {
    function BentoLineChartModule() {
    }
BentoLineChartModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoLineChartModule });
BentoLineChartModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoLineChartModule_Factory(t) { return new (t || BentoLineChartModule)(); }, providers: [BentoD3ChartService, BentoD3ColorService], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoLineChartModule, { declarations: function () { return [BentoD3LineChartComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BentoD3LineChartComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoLineChartModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [BentoD3LineChartComponent],
                providers: [BentoD3ChartService, BentoD3ColorService],
                exports: [BentoD3LineChartComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoLineChartModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pie-chart/pie-chart.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoPieChartModule = /** @class */ (function () {
    function BentoPieChartModule() {
    }
BentoPieChartModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoPieChartModule });
BentoPieChartModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoPieChartModule_Factory(t) { return new (t || BentoPieChartModule)(); }, providers: [BentoD3ChartService, BentoD3ColorService] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoPieChartModule, { declarations: [BentoD3PieChartComponent], exports: [BentoD3PieChartComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoPieChartModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoD3PieChartComponent],
                providers: [BentoD3ChartService, BentoD3ColorService],
                exports: [BentoD3PieChartComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoPieChartModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoD3Module = /** @class */ (function () {
    function BentoD3Module() {
    }
BentoD3Module.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoD3Module });
BentoD3Module.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoD3Module_Factory(t) { return new (t || BentoD3Module)(); }, providers: [WindowRef], imports: [BentoBarChartModule,
        BentoColumnChartModule,
        BentoPieChartModule,
        BentoArcGaugeModule,
        BentoLineChartModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoD3Module, { exports: [BentoBarChartModule,
        BentoColumnChartModule,
        BentoPieChartModule,
        BentoArcGaugeModule,
        BentoLineChartModule] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoD3Module, [{
        type: NgModule,
        args: [{
                exports: [
                    BentoBarChartModule,
                    BentoColumnChartModule,
                    BentoPieChartModule,
                    BentoArcGaugeModule,
                    BentoLineChartModule
                ],
                providers: [WindowRef]
            }]
    }], function () { return []; }, null); })();
    return BentoD3Module;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: bento-bento-ng-d3.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BentoD3ArcGaugeComponent, BentoD3BarChartComponent, BentoD3ColumnChartComponent, BentoD3LineChartComponent, BentoD3Module, BentoD3PieChartComponent, BentoBarChartModule as ɵa, BentoD3ColorService as ɵb, BentoD3ChartService as ɵc, BentoColumnChartModule as ɵd, BentoPieChartModule as ɵe, BentoArcGaugeModule as ɵf, BentoLineChartModule as ɵg };

//# sourceMappingURL=bento-bento-ng-d3.js.map